import classNames from 'classnames';
import React from 'react';

const IconCollection = props => {
  const { icon, className, disabled, width, height } = props;
  switch (icon) {
    case 'howItWorksInfo':
      return (
        <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.5 2.25C7.29 2.25 2.25 7.29 2.25 13.5C2.25 19.71 7.29 24.75 13.5 24.75C19.71 24.75 24.75 19.71 24.75 13.5C24.75 7.29 19.71 2.25 13.5 2.25ZM13.5 19.125C12.8813 19.125 12.375 18.6187 12.375 18V13.5C12.375 12.8813 12.8813 12.375 13.5 12.375C14.1187 12.375 14.625 12.8813 14.625 13.5V18C14.625 18.6187 14.1187 19.125 13.5 19.125ZM14.625 10.125H12.375V7.875H14.625V10.125Z" fill="black" />
        </svg>

      );
    case 'worldIcon':
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19.3 16.9C19.7 16.2 20 15.4 20 14.5C20 12 18 10 15.5 10C13 10 11 12 11 14.5C11 17 13 19 15.5 19C16.4 19 17.2 18.7 17.9 18.3L21.1 21.5L22.5 20.1L19.3 16.9ZM15.5 17C14.1 17 13 15.9 13 14.5C13 13.1 14.1 12 15.5 12C16.9 12 18 13.1 18 14.5C18 15.9 16.9 17 15.5 17ZM12 20V22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C16.84 2 20.87 5.44 21.8 10H19.73C19.4181 8.79184 18.8279 7.67338 18.0066 6.73401C17.1853 5.79465 16.1557 5.06042 15 4.59V5C15 6.1 14.1 7 13 7H11V9C11 9.55 10.55 10 10 10H8V12H10V15H9L4.21 10.21C4.08 10.79 4 11.38 4 12C4 16.41 7.59 20 12 20Z" fill="white" />
        </svg>
      );
    case 'quote_close_icon':
      return (
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.75 4.25L4.25 12.75M4.25 4.25L12.75 12.75" stroke="#484133" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

      );
    case 'footer_logo':
      return (
        <svg width="113" height="57" viewBox="0 0 113 57" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 7.97069V1.39453H23.1138V7.97069H15.2974V34.2753H7.80961V7.97069H0Z" fill="white" />
          <path d="M22.4336 34.2753V13.8295H29.4857V16.7791H29.5661C29.6198 16.6718 29.7036 16.5411 29.8209 16.3836C29.9415 16.2227 30.1996 15.9445 30.5985 15.5456C31.0007 15.1484 31.4264 14.7915 31.8789 14.4731C32.3297 14.1513 32.9129 13.8664 33.6285 13.615C34.3474 13.3603 35.0781 13.2329 35.8205 13.2329C36.5931 13.2329 37.3506 13.3402 38.093 13.5547C38.8388 13.7658 39.3835 13.977 39.7287 14.1915L40.2851 14.5066L37.3355 20.4861C36.459 19.7454 35.2373 19.3733 33.6687 19.3733C32.819 19.3733 32.0883 19.5594 31.4767 19.9297C30.8633 20.3018 30.4326 20.7526 30.1829 21.2838C29.9315 21.8168 29.7538 22.2676 29.6466 22.638C29.5393 23.01 29.4857 23.3016 29.4857 23.5161V34.2753H22.4336Z" fill="white" />
          <path d="M40.2832 31.748C38.3693 29.6616 37.4141 27.1025 37.4141 24.0725C37.4141 21.0425 38.3693 18.4801 40.2832 16.3836C42.1954 14.2837 44.6271 13.2329 47.5766 13.2329C50.2848 13.2329 52.5138 14.0843 54.2667 15.787V13.8295H61.3255V34.2753H54.3472V31.9626H54.2667C52.5138 33.9032 50.2848 34.8719 47.5766 34.8719C44.6271 34.8719 42.1954 33.8312 40.2832 31.748ZM46.2761 20.6068C45.3594 21.5101 44.9019 22.6648 44.9019 24.0725C44.9019 25.4803 45.3393 26.6299 46.2158 27.5181C47.0956 28.408 48.2537 28.8521 49.6882 28.8521C51.0691 28.8521 52.2037 28.4013 53.0936 27.498C53.9818 26.5964 54.4276 25.4534 54.4276 24.0725C54.4276 22.6648 53.9684 21.5101 53.0534 20.6068C52.1367 19.7052 51.0155 19.2527 49.6882 19.2527C48.3341 19.2527 47.1962 19.7052 46.2761 20.6068Z" fill="white" />
          <path d="M67.902 13.8296L72.8827 24.9507L77.8634 13.8296H86.2294L75.2692 34.2753H70.4896L59.5293 13.8296H67.902Z" fill="white" />
          <path d="M105.116 25.0311H90.2946C90.2946 26.4657 90.7588 27.5299 91.6889 28.222C92.6174 28.9108 93.6279 29.2543 94.7189 29.2543C95.8585 29.2543 96.7585 29.1035 97.4204 28.7985C98.0858 28.4901 98.8449 27.8851 99.6996 26.9818L104.801 29.5359C102.673 33.0938 99.1382 34.8719 94.196 34.8719C91.1158 34.8719 88.4729 33.8178 86.2658 31.7078C84.062 29.5945 82.9609 27.0489 82.9609 24.0725C82.9609 21.0961 84.062 18.5471 86.2658 16.4238C88.4729 14.2971 91.1158 13.2329 94.196 13.2329C97.4406 13.2329 100.077 14.1697 102.106 16.0417C104.139 17.9153 105.156 20.5917 105.156 24.0725C105.156 24.5518 105.143 24.8702 105.116 25.0311ZM90.489 21.123H98.2651C98.1042 20.0605 97.6836 19.2443 97.0048 18.6762C96.3294 18.1047 95.4597 17.8181 94.3972 17.8181C93.2257 17.8181 92.2939 18.1248 91.6018 18.7365C90.913 19.3449 90.5426 20.1409 90.489 21.123Z" fill="white" />
          <path d="M105.078 34.2751V0H112.13V34.2751H105.078Z" fill="white" />
          <path d="M61.9297 40.1704H70.1013V42.577H67.3327V56.9963H64.6915V42.577H61.9297V40.1704Z" fill="white" />
          <path d="M79.2316 56.9963C79.1997 56.8857 79.1662 56.7817 79.131 56.6879C79.0992 56.5907 79.0724 56.47 79.0506 56.3259C79.0271 56.1784 79.012 55.9941 79.0037 55.7695C78.9936 55.5466 78.9903 55.2668 78.9903 54.9316V52.2837C78.9903 51.5027 78.8528 50.9497 78.5813 50.6279C78.3082 50.3061 77.8674 50.1453 77.2607 50.1453H76.3491V56.9963H73.7012V40.1704H77.6965C79.0724 40.1704 80.0695 40.4922 80.6862 41.1357C81.303 41.7759 81.6113 42.7446 81.6113 44.045V45.3656C81.6113 47.0952 81.0348 48.2331 79.8818 48.7777C80.5522 49.0509 81.0097 49.495 81.256 50.1117C81.5058 50.7285 81.6314 51.4776 81.6314 52.3574V54.9517C81.6314 55.3673 81.6465 55.7326 81.6784 56.0444C81.7136 56.3577 81.794 56.6745 81.9197 56.9963H79.2316ZM76.3491 42.577V47.7454H77.3814C77.8775 47.7454 78.2663 47.618 78.5478 47.3633C78.8294 47.1052 78.9701 46.6376 78.9701 45.9623V44.3065C78.9701 43.6998 78.8595 43.2591 78.6417 42.9859C78.4272 42.7144 78.087 42.577 77.6227 42.577H76.3491Z" fill="white" />
          <path d="M85.7656 40.1704H88.4135V56.9963H85.7656V40.1704Z" fill="white" />
          <path d="M96.7316 40.1704C98.1075 40.1704 99.1047 40.4922 99.7214 41.1357C100.338 41.7759 100.646 42.7446 100.646 44.045V44.6417C100.646 45.5098 100.509 46.2237 100.238 46.7868C99.9644 47.3465 99.5304 47.7622 98.9371 48.0336C99.6611 48.3068 100.171 48.7509 100.465 49.3676C100.76 49.9844 100.908 50.7419 100.908 51.6401V53.0077C100.908 54.3048 100.569 55.2936 99.8957 55.9773C99.2253 56.6577 98.2265 56.9963 96.8992 56.9963H92.7363V40.1704H96.7316ZM95.3842 49.428V54.5897H96.8992C97.345 54.5897 97.6852 54.4724 97.9182 54.2344C98.1494 53.9931 98.2667 53.5607 98.2667 52.9339V51.4659C98.2667 50.6849 98.1343 50.1503 97.8712 49.8637C97.6064 49.5738 97.169 49.428 96.5573 49.428H95.3842ZM95.3842 42.577V47.0214H96.4166C96.9126 47.0214 97.3014 46.894 97.583 46.6393C97.8645 46.3846 98.0053 45.9204 98.0053 45.245V44.3065C98.0053 43.6998 97.8947 43.2591 97.6768 42.9859C97.4623 42.7144 97.1221 42.577 96.6579 42.577H95.3842Z" fill="white" />
          <path d="M107.542 47.2627H111.169V49.6693H107.542V54.5897H112.108V56.9963H104.895V40.1704H112.108V42.577H107.542V47.2627Z" fill="white" />
        </svg>
      );
    case 'downLoadIcon':
      return (
        <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.9998 13.6281C10.8776 13.6281 10.763 13.61 10.6561 13.5739C10.5491 13.5377 10.4498 13.4756 10.3582 13.3875L7.05817 10.2375C6.87484 10.0625 6.78684 9.85834 6.79417 9.625C6.8015 9.39167 6.8895 9.1875 7.05817 9.0125C7.2415 8.8375 7.45936 8.7465 7.71175 8.7395C7.96414 8.7325 8.1817 8.81621 8.36442 8.99063L10.0832 10.6313V4.375C10.0832 4.12709 10.1712 3.91942 10.3472 3.752C10.5232 3.58459 10.7407 3.50059 10.9998 3.5C11.2589 3.49942 11.4768 3.58342 11.6534 3.752C11.83 3.92059 11.9177 4.12825 11.9165 4.375V10.6313L13.6353 8.99063C13.8186 8.81563 14.0364 8.73163 14.2888 8.73863C14.5412 8.74563 14.7588 8.83692 14.9415 9.0125C15.1096 9.1875 15.1976 9.39167 15.2055 9.625C15.2134 9.85834 15.1254 10.0625 14.9415 10.2375L11.6415 13.3875C11.5498 13.475 11.4505 13.5371 11.3436 13.5739C11.2366 13.6106 11.1221 13.6287 10.9998 13.6281ZM5.49984 17.5C4.99567 17.5 4.56423 17.3288 4.2055 16.9864C3.84678 16.644 3.66712 16.2318 3.6665 15.75V14C3.6665 13.7521 3.7545 13.5444 3.9305 13.377C4.1065 13.2096 4.32406 13.1256 4.58317 13.125C4.84228 13.1244 5.06014 13.2084 5.23675 13.377C5.41336 13.5456 5.50106 13.7533 5.49984 14V15.75H16.4998V14C16.4998 13.7521 16.5878 13.5444 16.7638 13.377C16.9398 13.2096 17.1574 13.1256 17.4165 13.125C17.6756 13.1244 17.8935 13.2084 18.0701 13.377C18.2467 13.5456 18.3344 13.7533 18.3332 14V15.75C18.3332 16.2313 18.1538 16.6434 17.7951 16.9864C17.4364 17.3294 17.0046 17.5006 16.4998 17.5H5.49984Z" fill="white" />
        </svg>

      );
    case 'fileIcon':
      return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.99998 4.66667H13.6666L9.99998 1V4.66667ZM5.33331 0H10.6666L14.6666 4V12C14.6666 12.3536 14.5262 12.6928 14.2761 12.9428C14.0261 13.1929 13.6869 13.3333 13.3333 13.3333H5.33331C4.97969 13.3333 4.64055 13.1929 4.3905 12.9428C4.14046 12.6928 3.99998 12.3536 3.99998 12V1.33333C3.99998 0.979711 4.14046 0.640573 4.3905 0.390524C4.64055 0.140476 4.97969 0 5.33331 0ZM2.66665 2.66667V14.6667H13.3333V16H2.66665C2.31302 16 1.97389 15.8595 1.72384 15.6095C1.47379 15.3594 1.33331 15.0203 1.33331 14.6667V2.66667H2.66665Z" fill="#4B4745" />
        </svg>


      );
    case 'checkIcon':
      return (
        <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" clipRule="evenodd" d="M2.63662 7.78248L0.357369 5.64479C-0.119123 5.17089 -0.119123 4.40293 0.357369 3.9266C0.835083 3.4527 1.60847 3.4527 2.08618 3.9266L3.34647 5.05208L6.17217 0.505847C6.56558 -0.0373165 7.32674 -0.16369 7.87776 0.227582C8.42512 0.618854 8.55096 1.37831 8.15755 1.92269L4.4925 7.6318C4.27258 7.93801 3.91215 8.13851 3.50042 8.13851C3.17787 8.13851 2.86754 8.01214 2.63662 7.78248Z" fill="#373737" />
        </svg>

      );
    case 'travelStyle':
      return (
        <svg
          width="20"
          height="17"
          viewBox="0 0 20 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14 3H16V17H4V3H6V2C6 1.46957 6.21071 0.960859 6.58579 0.585786C6.96086 0.210714 7.46957 0 8 0H12C12.5304 0 13.0391 0.210714 13.4142 0.585786C13.7893 0.960859 14 1.46957 14 2V3ZM17 3H18C18.5304 3 19.0391 3.21071 19.4142 3.58579C19.7893 3.96086 20 4.46957 20 5V15C20 15.5304 19.7893 16.0391 19.4142 16.4142C19.0391 16.7893 18.5304 17 18 17H17V3ZM3 3V17H2C1.46957 17 0.960859 16.7893 0.585786 16.4142C0.210714 16.0391 0 15.5304 0 15V5C0 3.9 0.9 3 2 3H3ZM8 2V3H12V2H8Z"
            fill="white"
          />
        </svg>
      );
    case 'iconPlus':
      return (
        <svg
          width="21"
          height="23"
          viewBox="0 0 21 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.375 10.1675V0.847294C9.375 0.622577 9.45731 0.407065 9.60382 0.248167C9.75034 0.0892681 9.94905 0 10.1562 0C10.3635 0 10.5622 0.0892681 10.7087 0.248167C10.8552 0.407065 10.9375 0.622577 10.9375 0.847294V10.1675H19.5312C19.7385 10.1675 19.9372 10.2568 20.0837 10.4157C20.2302 10.5746 20.3125 10.7901 20.3125 11.0148C20.3125 11.2395 20.2302 11.455 20.0837 11.6139C19.9372 11.7728 19.7385 11.8621 19.5312 11.8621H10.9375V21.1823C10.9375 21.4071 10.8552 21.6226 10.7087 21.7815C10.5622 21.9404 10.3635 22.0296 10.1562 22.0296C9.94905 22.0296 9.75034 21.9404 9.60382 21.7815C9.45731 21.6226 9.375 21.4071 9.375 21.1823V11.8621H0.78125C0.57405 11.8621 0.375336 11.7728 0.228823 11.6139C0.08231 11.455 0 11.2395 0 11.0148C0 10.7901 0.08231 10.5746 0.228823 10.4157C0.375336 10.2568 0.57405 10.1675 0.78125 10.1675H9.375Z"
            fill="#373737"
          />
        </svg>
      );
    case 'iconMinus':
      return (
        <svg
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.81865 8.92344L1.22825 2.33304C1.06935 2.17414 0.975166 1.96355 0.966408 1.74759C0.95765 1.53163 1.03504 1.328 1.18155 1.18148C1.32807 1.03497 1.5317 0.957581 1.74766 0.966339C1.96362 0.975097 2.17421 1.06929 2.33311 1.22818L8.9235 7.81858L15.0002 1.74188C15.1467 1.59537 15.3503 1.51798 15.5663 1.52674C15.7823 1.53549 15.9929 1.62968 16.1518 1.78858C16.3107 1.94748 16.4048 2.15807 16.4136 2.37403C16.4224 2.58999 16.345 2.79362 16.1985 2.94014L10.1218 9.01683L16.7122 15.6072C16.8711 15.7661 16.9652 15.9767 16.974 16.1927C16.9828 16.4086 16.9054 16.6123 16.7589 16.7588C16.6123 16.9053 16.4087 16.9827 16.1927 16.9739C15.9768 16.9652 15.7662 16.871 15.6073 16.7121L9.0169 10.1217L2.9402 16.1984C2.79369 16.3449 2.59006 16.4223 2.3741 16.4135C2.15814 16.4048 1.94755 16.3106 1.78865 16.1517C1.62975 15.9928 1.53556 15.7822 1.52681 15.5662C1.51805 15.3503 1.59544 15.1466 1.74195 15.0001L7.81865 8.92344Z"
            fill="#373737"
          />
        </svg>
      );
    case 'iconPlusWithDarkCircle':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="35"
          height="33"
          viewBox="0 0 35 33"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.2499 0C7.72327 0 0 7.3875 0 16.5C0 25.6125 7.72327 33 17.2499 33C26.7766 33 34.4999 25.6125 34.4999 16.5C34.4999 7.3875 26.7766 0 17.2499 0ZM18.8181 22.5C18.8181 22.8978 18.6529 23.2794 18.3588 23.5607C18.0647 23.842 17.6658 24 17.2499 24C16.834 24 16.4352 23.842 16.1411 23.5607C15.847 23.2794 15.6818 22.8978 15.6818 22.5V18H10.9772C10.5613 18 10.1625 17.842 9.86836 17.5607C9.57427 17.2794 9.40905 16.8978 9.40905 16.5C9.40905 16.1022 9.57427 15.7206 9.86836 15.4393C10.1625 15.158 10.5613 15 10.9772 15H15.6818V10.5C15.6818 10.1022 15.847 9.72064 16.1411 9.43934C16.4352 9.15804 16.834 9 17.2499 9C17.6658 9 18.0647 9.15804 18.3588 9.43934C18.6529 9.72064 18.8181 10.1022 18.8181 10.5V15H23.5226C23.9385 15 24.3374 15.158 24.6315 15.4393C24.9256 15.7206 25.0908 16.1022 25.0908 16.5C25.0908 16.8978 24.9256 17.2794 24.6315 17.5607C24.3374 17.842 23.9385 18 23.5226 18H18.8181V22.5Z"
            fill="black"
          />
        </svg>
      );
    case 'iconDarkCrossWithDarkBorder':
      return (
        <svg
          width="19"
          height="18"
          viewBox="0 0 19 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.0501 6.59998L6.9502 11.4M12.0501 11.4L6.9502 6.59998L12.0501 11.4Z"
            stroke="black"
            strokeOpacity="0.6"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M9.49991 17C14.1943 17 17.9998 13.4183 17.9998 9C17.9998 4.58172 14.1943 1 9.49991 1C4.80554 1 1 4.58172 1 9C1 13.4183 4.80554 17 9.49991 17Z"
            stroke="black"
            strokeOpacity="0.6"
            strokeWidth="2"
          />
        </svg>
      );
    case 'menu':
      return (
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 36H42V31.9997H6V36ZM6 25.9997H42V22.0003H6V25.9997ZM6 12V16.0003H42V12H6Z"
            fill="white"
          />
        </svg>
      );

    case 'plus-icon':
      return (
        <svg
          {...props}
          width="27"
          height="27"
          viewBox="0 0 27 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.484 1.6875C10.3666 1.72537 7.38755 2.98206 5.18306 5.18917C2.97856 7.39629 1.72337 10.3789 1.68555 13.5C1.72337 16.6211 2.97856 19.6037 5.18306 21.8108C7.38755 24.0179 10.3666 25.2746 13.484 25.3125C16.6014 25.2746 19.5805 24.0179 21.785 21.8108C23.9895 19.6037 25.2446 16.6211 25.2825 13.5C25.2446 10.3789 23.9895 7.39629 21.785 5.18917C19.5805 2.98206 16.6014 1.72537 13.484 1.6875ZM20.226 14.3438H14.3268V20.25H12.6413V14.3438H6.74203V12.6562H12.6413V6.75H14.3268V12.6562H20.226V14.3438Z"
            fill="white"
          />
        </svg>
      );
    case 'search-icon':
      return (
        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.58333 16.2917C13.2882 16.2917 16.2917 13.2882 16.2917 9.58333C16.2917 5.87842 13.2882 2.875 9.58333 2.875C5.87842 2.875 2.875 5.87842 2.875 9.58333C2.875 13.2882 5.87842 16.2917 9.58333 16.2917Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M14.375 14.375L20.125 20.125" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      );
    case 'icon-info':
      return (
        <svg
          width={width || 24}
          height={height || 24}
          viewBox="0 0 1.8 1.8"
          xmlns="http://www.w3.org/2000/svg"
          enableBackground="new 0 0 48 48"
        >
          <path
            fill="hsl(0 0% 100%)"
            cx={24}
            cy={24}
            r={21}
            d="M1.688 0.9A0.787 0.787 0 0 1 0.9 1.688A0.787 0.787 0 0 1 0.112 0.9A0.787 0.787 0 0 1 1.688 0.9z"
          />
          <path
            x={22}
            y={22}
            fill="#000"
            width={4}
            height={11}
            d="M0.825 0.825H0.975V1.238H0.825V0.825z"
          />
          <path
            fill="#000"
            cx={24}
            cy={16.5}
            r={2.5}
            d="M0.994 0.619A0.094 0.094 0 0 1 0.9 0.713A0.094 0.094 0 0 1 0.806 0.619A0.094 0.094 0 0 1 0.994 0.619z"
          />
        </svg>
      );

    case 'icon-star':
      return (
        <svg
          width="68"
          height="12"
          viewBox="0 0 68 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.9676 4.1779C11.8891 3.963 11.684 3.81792 11.4539 3.81792H7.50286L6.52547 0.395973C6.45784 0.161444 6.24404 0 5.99969 0C5.75644 0 5.54154 0.161444 5.475 0.395973L4.49652 3.81792H0.545519C0.315353 3.81792 0.111367 3.963 0.0328268 4.1779C-0.0457133 4.39388 0.0197368 4.63496 0.196452 4.78331L3.17007 7.26169L1.67017 11.2629C1.58618 11.4876 1.65926 11.7407 1.85016 11.8868C2.03887 12.033 2.30394 12.0374 2.49811 11.8977L5.99969 9.39754L9.50127 11.8977C9.69653 12.0374 9.96051 12.033 10.1503 11.8868C10.3412 11.7407 10.4132 11.4876 10.3292 11.2629L8.82932 7.26169L11.804 4.78331C11.9807 4.63496 12.0451 4.39388 11.9676 4.1779Z"
            fill="#F5D90A"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.9676 4.1779C25.8891 3.963 25.684 3.81792 25.4539 3.81792H21.5029L20.5255 0.395973C20.4578 0.161444 20.244 0 19.9997 0C19.7564 0 19.5415 0.161444 19.475 0.395973L18.4965 3.81792H14.5455C14.3154 3.81792 14.1114 3.963 14.0328 4.1779C13.9543 4.39388 14.0197 4.63496 14.1965 4.78331L17.1701 7.26169L15.6702 11.2629C15.5862 11.4876 15.6593 11.7407 15.8502 11.8868C16.0389 12.033 16.3039 12.0374 16.4981 11.8977L19.9997 9.39754L23.5013 11.8977C23.6965 12.0374 23.9605 12.033 24.1503 11.8868C24.3412 11.7407 24.4132 11.4876 24.3292 11.2629L22.8293 7.26169L25.804 4.78331C25.9807 4.63496 26.0451 4.39388 25.9676 4.1779Z"
            fill="#F5D90A"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M39.9676 4.1779C39.8891 3.963 39.684 3.81792 39.4539 3.81792H35.5029L34.5255 0.395973C34.4578 0.161444 34.244 0 33.9997 0C33.7564 0 33.5415 0.161444 33.475 0.395973L32.4965 3.81792H28.5455C28.3154 3.81792 28.1114 3.963 28.0328 4.1779C27.9543 4.39388 28.0197 4.63496 28.1965 4.78331L31.1701 7.26169L29.6702 11.2629C29.5862 11.4876 29.6593 11.7407 29.8502 11.8868C30.0389 12.033 30.3039 12.0374 30.4981 11.8977L33.9997 9.39754L37.5013 11.8977C37.6965 12.0374 37.9605 12.033 38.1503 11.8868C38.3412 11.7407 38.4132 11.4876 38.3292 11.2629L36.8293 7.26169L39.804 4.78331C39.9807 4.63496 40.0451 4.39388 39.9676 4.1779Z"
            fill="#F5D90A"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M53.9676 4.1779C53.8891 3.963 53.684 3.81792 53.4539 3.81792H49.5029L48.5255 0.395973C48.4578 0.161444 48.244 0 47.9997 0C47.7564 0 47.5415 0.161444 47.475 0.395973L46.4965 3.81792H42.5455C42.3154 3.81792 42.1114 3.963 42.0328 4.1779C41.9543 4.39388 42.0197 4.63496 42.1965 4.78331L45.1701 7.26169L43.6702 11.2629C43.5862 11.4876 43.6593 11.7407 43.8502 11.8868C44.0389 12.033 44.3039 12.0374 44.4981 11.8977L47.9997 9.39754L51.5013 11.8977C51.6965 12.0374 51.9605 12.033 52.1503 11.8868C52.3412 11.7407 52.4132 11.4876 52.3292 11.2629L50.8293 7.26169L53.804 4.78331C53.9807 4.63496 54.0451 4.39388 53.9676 4.1779Z"
            fill="#F5D90A"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M67.9676 4.1779C67.8891 3.963 67.684 3.81792 67.4539 3.81792H63.5029L62.5255 0.395973C62.4578 0.161444 62.244 0 61.9997 0C61.7564 0 61.5415 0.161444 61.475 0.395973L60.4965 3.81792H56.5455C56.3154 3.81792 56.1114 3.963 56.0328 4.1779C55.9543 4.39388 56.0197 4.63496 56.1965 4.78331L59.1701 7.26169L57.6702 11.2629C57.5862 11.4876 57.6593 11.7407 57.8502 11.8868C58.0389 12.033 58.3039 12.0374 58.4981 11.8977L61.9997 9.39754L65.5013 11.8977C65.6965 12.0374 65.9605 12.033 66.1503 11.8868C66.3412 11.7407 66.4132 11.4876 66.3292 11.2629L64.8293 7.26169L67.804 4.78331C67.9807 4.63496 68.0451 4.39388 67.9676 4.1779Z"
            fill="#F5D90A"
          />
        </svg>
      );

    case 'icon-plus':
      return (
        <svg
          width="35"
          height="33"
          viewBox="0 0 35 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.2499 0C7.72327 0 0 7.3875 0 16.5C0 25.6125 7.72327 33 17.2499 33C26.7766 33 34.4999 25.6125 34.4999 16.5C34.4999 7.3875 26.7766 0 17.2499 0ZM18.8181 22.5C18.8181 22.8978 18.6529 23.2794 18.3588 23.5607C18.0647 23.842 17.6658 24 17.2499 24C16.834 24 16.4352 23.842 16.1411 23.5607C15.847 23.2794 15.6818 22.8978 15.6818 22.5V18H10.9772C10.5613 18 10.1625 17.842 9.86836 17.5607C9.57427 17.2794 9.40905 16.8978 9.40905 16.5C9.40905 16.1022 9.57427 15.7206 9.86836 15.4393C10.1625 15.158 10.5613 15 10.9772 15H15.6818V10.5C15.6818 10.1022 15.847 9.72064 16.1411 9.43934C16.4352 9.15804 16.834 9 17.2499 9C17.6658 9 18.0647 9.15804 18.3588 9.43934C18.6529 9.72064 18.8181 10.1022 18.8181 10.5V15H23.5226C23.9385 15 24.3374 15.158 24.6315 15.4393C24.9256 15.7206 25.0908 16.1022 25.0908 16.5C25.0908 16.8978 24.9256 17.2794 24.6315 17.5607C24.3374 17.842 23.9385 18 23.5226 18H18.8181V22.5Z"
            fill="white"
          />
        </svg>
      );

    case 'icon-close':
      return (
        <svg
          fill="#000000"
          width="20px"
          height="20px"
          viewBox="-0.135 -0.135 0.54 0.54"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="xMinYMin"
          class="jam jam-close"
        >
          <path d="m0.165 0.133 0.08 -0.08A0.022 0.022 0 1 0 0.212 0.021L0.133 0.101 0.053 0.021A0.022 0.022 0 1 0 0.021 0.053l0.08 0.08L0.021 0.212a0.022 0.022 0 1 0 0.032 0.032l0.08 -0.08 0.08 0.08a0.022 0.022 0 1 0 0.032 -0.032L0.165 0.133z" />
        </svg>
      );

    case 'icon-upload':
      return (
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M38.5 27.5V34.8333C38.5 35.8058 38.1137 36.7384 37.4261 37.4261C36.7384 38.1137 35.8058 38.5 34.8333 38.5H9.16667C8.19421 38.5 7.26158 38.1137 6.57394 37.4261C5.88631 36.7384 5.5 35.8058 5.5 34.8333V27.5M31.1667 14.6667L22 5.5M22 5.5L12.8333 14.6667M22 5.5V27.5"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'icon-edit':
      return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <g clipPath="url(#clip0_2253_9496)">
            <path
              d="M1.87534 10.3113L1.0309 13.9557C1.00177 14.089 1.00277 14.227 1.03382 14.3598C1.06488 14.4926 1.1252 14.6168 1.21039 14.7232C1.29558 14.8297 1.40349 14.9158 1.52622 14.9753C1.64895 15.0347 1.78342 15.066 1.91979 15.0668C1.98331 15.0737 2.04738 15.0737 2.1109 15.0668L5.77756 14.2224L12.8176 7.20906L8.88868 3.28906L1.87534 10.3113Z"
              fill="white"
            />
            <path
              d="M15.0321 3.69766L12.4099 1.07543C12.2375 0.903907 12.0042 0.807617 11.761 0.807617C11.5178 0.807617 11.2845 0.903907 11.1121 1.07543L9.6543 2.53321L13.5787 6.45766L15.0365 4.99988C15.1218 4.91414 15.1894 4.81241 15.2354 4.70053C15.2813 4.58865 15.3047 4.4688 15.3043 4.34785C15.3039 4.22689 15.2797 4.10721 15.2329 3.99564C15.1862 3.88407 15.118 3.78281 15.0321 3.69766Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_2253_9496">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    case 'icon-video-upload':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="52"
          height="52"
          viewBox="0 0 52 52"
          fill="none"
        >
          <path
            d="M11.3743 8.6665C9.50678 8.6665 7.71571 9.40839 6.39514 10.729C5.07457 12.0495 4.33268 13.8406 4.33268 15.7082V27.7548C5.2993 26.8255 6.39368 26.039 7.58268 25.4192V15.7082C7.58268 13.6152 9.28135 11.9165 11.3743 11.9165H27.6243C29.7173 11.9165 31.416 13.6152 31.416 15.7082V31.9582C31.4163 32.8994 31.0664 33.8072 30.4345 34.5048C29.8025 35.2024 28.9337 35.64 27.997 35.7325C28.1638 36.8074 28.2074 37.8978 28.127 38.9825C29.9031 38.8554 31.5651 38.0601 32.7784 36.7568C33.9917 35.4534 34.6662 33.7388 34.666 31.9582V31.2822L41.725 36.1572C44.2383 37.8905 47.6703 36.0922 47.6703 33.0372V14.627C47.6703 11.572 44.2383 9.76934 41.725 11.507L34.666 16.3842V15.7082C34.666 13.8406 33.9241 12.0495 32.6036 10.729C31.283 9.40839 29.4919 8.6665 27.6243 8.6665H11.3743ZM34.666 20.3318L43.571 14.1828C43.6524 14.1267 43.7475 14.0939 43.8461 14.088C43.9448 14.082 44.0432 14.1032 44.1307 14.1492C44.2181 14.1951 44.2914 14.2642 44.3424 14.3488C44.3935 14.4334 44.4204 14.5303 44.4203 14.6292V33.035C44.4204 33.1338 44.3935 33.2308 44.3424 33.3154C44.2914 33.4 44.2181 33.469 44.1307 33.515C44.0432 33.561 43.9448 33.5822 43.8461 33.5762C43.7475 33.5703 43.6524 33.5375 43.571 33.4813L34.666 27.3323V20.3318ZM25.9993 37.9165C25.9993 36.3516 25.6911 34.802 25.0922 33.3562C24.4934 31.9104 23.6156 30.5967 22.509 29.4901C21.4025 28.3836 20.0888 27.5058 18.643 26.9069C17.1972 26.3081 15.6476 25.9998 14.0827 25.9998C12.5178 25.9998 10.9682 26.3081 9.52237 26.9069C8.07657 27.5058 6.76289 28.3836 5.65633 29.4901C4.54976 30.5967 3.67199 31.9104 3.07312 33.3562C2.47425 34.802 2.16602 36.3516 2.16602 37.9165C2.16602 41.077 3.42152 44.1081 5.65633 46.3429C7.89113 48.5777 10.9222 49.8332 14.0827 49.8332C17.2432 49.8332 20.2742 48.5777 22.509 46.3429C24.7438 44.1081 25.9993 41.077 25.9993 37.9165ZM15.166 38.9998L15.1682 44.423C15.1682 44.7103 15.054 44.9859 14.8509 45.189C14.6477 45.3922 14.3722 45.5063 14.0848 45.5063C13.7975 45.5063 13.522 45.3922 13.3188 45.189C13.1157 44.9859 13.0015 44.7103 13.0015 44.423V38.9998H7.57402C7.2867 38.9998 7.01115 38.8857 6.80798 38.6825C6.60482 38.4794 6.49068 38.2038 6.49068 37.9165C6.49068 37.6292 6.60482 37.3536 6.80798 37.1505C7.01115 36.9473 7.2867 36.8332 7.57402 36.8332H12.9993V31.4165C12.9993 31.1292 13.1135 30.8536 13.3166 30.6505C13.5198 30.4473 13.7954 30.3332 14.0827 30.3332C14.37 30.3332 14.6455 30.4473 14.8487 30.6505C15.0519 30.8536 15.166 31.1292 15.166 31.4165V36.8332H20.5762C20.8635 36.8332 21.139 36.9473 21.3422 37.1505C21.5454 37.3536 21.6595 37.6292 21.6595 37.9165C21.6595 38.2038 21.5454 38.4794 21.3422 38.6825C21.139 38.8857 20.8635 38.9998 20.5762 38.9998H15.166Z"
            fill="white"
          />
        </svg>
      );

    case 'icon-img-upload':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
        >
          <path
            d="M44 24C44 22.8954 43.1046 22 42 22C40.8954 22 40 22.8954 40 24H44ZM24 8C25.1046 8 26 7.10457 26 6C26 4.89543 25.1046 4 24 4V8ZM39 40H9V44H39V40ZM8 39V9H4V39H8ZM40 24V39H44V24H40ZM9 8H24V4H9V8ZM9 40C8.44772 40 8 39.5523 8 39H4C4 41.7614 6.23857 44 9 44V40ZM39 44C41.7614 44 44 41.7614 44 39H40C40 39.5523 39.5523 40 39 40V44ZM8 9C8 8.44772 8.44771 8 9 8V4C6.23858 4 4 6.23857 4 9H8Z"
            fill="white"
          />
          <path
            d="M6 35.0001L16.6931 25.1981C17.4389 24.5144 18.5779 24.4954 19.3461 25.1539L32 36.0001"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M28 30.9999L32.7735 26.2264C33.4772 25.5227 34.5914 25.4435 35.3877 26.0407L42 30.9999"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M30 12H42"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M36 6V18"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'icon-arrow-down':
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="6"
            viewBox="0 0 12 6"
            fill="none"
          >
            <path
              d="M6.37383 5.8583L11.8574 0.766689C11.9489 0.681733 12 0.568863 12 0.451489C12 0.334116 11.9489 0.221247 11.8574 0.136291L11.8512 0.130809C11.8068 0.0894813 11.7534 0.0565729 11.6942 0.0340853C11.635 0.0115976 11.5712 9.20865e-07 11.5068 9.15935e-07C11.4424 9.11004e-07 11.3786 0.0115976 11.3194 0.0340852C11.2602 0.0565729 11.2068 0.0894813 11.1624 0.130809L5.99897 4.92549L0.837607 0.130808C0.793229 0.0894805 0.739812 0.0565721 0.680605 0.0340844C0.621398 0.0115968 0.557639 7.81139e-08 0.493207 7.31836e-08C0.428774 6.82533e-08 0.365015 0.0115967 0.305808 0.0340844C0.246601 0.056572 0.193184 0.0894805 0.148806 0.130808L0.142609 0.13629C0.051067 0.221246 -3.87766e-07 0.334115 -3.99489e-07 0.451489C-4.11212e-07 0.568862 0.0510669 0.681732 0.142609 0.766688L5.62617 5.8583C5.67439 5.90308 5.73239 5.93872 5.79665 5.96308C5.86091 5.98744 5.93009 6 6 6C6.06991 6 6.13909 5.98744 6.20335 5.96308C6.26761 5.93872 6.32561 5.90308 6.37383 5.8583Z"
              fill="white"
            />
          </svg>
        </>
      );

    case 'icon-wishlist':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="26"
          viewBox="0 0 25 26"
          fill="none"
        >
          <mask
            id="mask0_2335_2603"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="1"
            y="1"
            width="23"
            height="23"
          >
            <path
              d="M12.4167 22.8333C13.7849 22.835 15.1399 22.5664 16.4039 22.0428C17.6679 21.5192 18.8161 20.751 19.7823 19.7823C20.751 18.8161 21.5192 17.6679 22.0428 16.4039C22.5664 15.1399 22.835 13.7849 22.8333 12.4167C22.835 11.0485 22.5664 9.69346 22.0428 8.42943C21.5192 7.1654 20.751 6.01728 19.7823 5.05105C18.8161 4.08238 17.6679 3.31418 16.4039 2.79059C15.1399 2.26699 13.7849 1.99832 12.4167 2.00001C11.0485 1.99832 9.69346 2.26699 8.42943 2.79059C7.1654 3.31418 6.01728 4.08238 5.05105 5.05105C4.08238 6.01728 3.31418 7.1654 2.79059 8.42943C2.26699 9.69346 1.99832 11.0485 2.00001 12.4167C1.99832 13.7849 2.26699 15.1399 2.79059 16.4039C3.31418 17.6679 4.08238 18.8161 5.05105 19.7823C6.01728 20.751 7.1654 21.5192 8.42943 22.0428C9.69346 22.5664 11.0485 22.835 12.4167 22.8333Z"
              fill="white"
              stroke="white"
              strokeWidth="2"
              strokeLinejoin="round"
            />
            <path
              d="M8.25 12.4165L11.375 15.5415L17.625 9.2915"
              stroke="black"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </mask>
          <g mask="url(#mask0_2335_2603)">
            <path d="M-0.0839844 -0.0834961H24.916V24.9165H-0.0839844V-0.0834961Z" fill="white" />
          </g>
        </svg>
      );
    case 'icon-wishlist-active':
      return (
        <svg
          width="22px"
          height="22px"
          viewBox="0 0 0.469 0.469"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0.234a0.234 0.234 0 1 1 0.469 0 0.234 0.234 0 0 1 -0.469 0m0.221 0.1 0.135 -0.169 -0.024 -0.019 -0.115 0.144L0.135 0.222l-0.02 0.024z"
            fill="#000000"
          />
        </svg>
      );

    case 'icon-watch-trailer':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
        >
          <mask
            id="mask0_2335_2623"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="25"
            height="24"
          >
            <path
              d="M12.5 22C18.023 22 22.5 17.523 22.5 12C22.5 6.477 18.023 2 12.5 2C6.977 2 2.5 6.477 2.5 12C2.5 17.523 6.977 22 12.5 22Z"
              fill="white"
              stroke="white"
              strokeWidth="4"
              strokeLinejoin="round"
            />
            <path
              d="M10.5 12.0001V8.53613L13.5 10.2681L16.5 12.0001L13.5 13.7321L10.5 15.4641V12.0001Z"
              fill="black"
              stroke="black"
              strokeWidth="4"
              strokeLinejoin="round"
            />
          </mask>
          <g mask="url(#mask0_2335_2623)">
            <path d="M0.5 0H24.5V24H0.5V0Z" fill="white" />
          </g>
        </svg>
      );

    case 'icon-draft-overlay':
      return (
        <svg
          width="87"
          height="87"
          viewBox="0 0 87 87"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M47.125 68.875C47.125 70.1075 47.27 71.3037 47.4513 72.5H14.5C12.5772 72.5 10.7331 71.7362 9.37348 70.3765C8.01384 69.0169 7.25 67.1728 7.25 65.25V21.75C7.25 19.8272 8.01384 17.9831 9.37348 16.6235C10.7331 15.2638 12.5772 14.5 14.5 14.5H18.125L25.375 29H36.25L29 14.5H36.25L43.5 29H54.375L47.125 14.5H54.375L61.625 29H72.5L65.25 14.5H79.75V50.0613C77.5387 48.7925 75.11 47.9225 72.5 47.4513V36.25H20.88L14.5 23.4537V65.25H47.4513C47.27 66.4463 47.125 67.6425 47.125 68.875ZM72.5 65.25V54.375H65.25V65.25H54.375V72.5H65.25V83.375H72.5V72.5H83.375V65.25H72.5Z"
            fill="white"
          />
        </svg>
      );

    case 'icon-draft-overlay-2':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="87"
          height="87"
          viewBox="0 0 87 87"
          fill="none"
        >
          <path
            d="M47.125 68.875C47.125 70.1075 47.27 71.3037 47.4513 72.5H14.5C12.5772 72.5 10.7331 71.7362 9.37348 70.3765C8.01384 69.0169 7.25 67.1728 7.25 65.25V21.75C7.25 19.8272 8.01384 17.9831 9.37348 16.6235C10.7331 15.2638 12.5772 14.5 14.5 14.5H18.125L25.375 29H36.25L29 14.5H36.25L43.5 29H54.375L47.125 14.5H54.375L61.625 29H72.5L65.25 14.5H79.75V50.0613C77.5387 48.7925 75.11 47.9225 72.5 47.4513V36.25H20.88L14.5 23.4537V65.25H47.4513C47.27 66.4463 47.125 67.6425 47.125 68.875ZM72.5 65.25V54.375H65.25V65.25H54.375V72.5H65.25V83.375H72.5V72.5H83.375V65.25H72.5Z"
            fill="black"
          />
        </svg>
      );

    case 'edit-pencil-icon':
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_2253_12323)">
            <path
              d="M1.87559 10.3111L1.03114 13.9555C1.00201 14.0888 1.00301 14.2268 1.03406 14.3596C1.06512 14.4924 1.12545 14.6166 1.21064 14.7231C1.29583 14.8296 1.40373 14.9157 1.52646 14.9751C1.6492 15.0346 1.78366 15.0658 1.92003 15.0667C1.98355 15.0735 2.04762 15.0735 2.11114 15.0667L5.77781 14.2222L12.8178 7.20888L8.88892 3.28888L1.87559 10.3111Z"
              fill="black"
            />
            <path
              d="M15.0311 3.69778L12.4089 1.07556C12.2365 0.904029 12.0032 0.807739 11.76 0.807739C11.5168 0.807739 11.2835 0.904029 11.1111 1.07556L9.65332 2.53333L13.5778 6.45778L15.0355 5C15.1209 4.91426 15.1884 4.81253 15.2344 4.70065C15.2803 4.58877 15.3038 4.46892 15.3034 4.34797C15.3029 4.22701 15.2787 4.10733 15.232 3.99576C15.1853 3.8842 15.117 3.78294 15.0311 3.69778Z"
              fill="black"
            />
          </g>
          <defs>
            <clipPath id="clip0_2253_12323">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    case 'icon-share':
      return (
        <svg
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.5427 7.20246V2.69412L18.4458 7.59725L22.3771 11.5285L18.376 14.8629L13.5427 18.891V14.4795C5.05728 13.84 2.08437 18.7504 2.08437 18.7504C2.08437 15.691 2.33645 12.516 4.74166 10.1118C7.53749 7.31496 11.5865 7.11704 13.5427 7.20246Z"
            fill="white"
          />
        </svg>
      );

    case 'icon-close-white':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 18 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="4" y="4" width="16" height="16" fill="#171819" />
          <path
            d="M17.2074 15.7926L17.2074 15.7926L13.4139 12L17.2074 8.20742L17.2074 8.2074C17.395 8.01979 17.5004 7.76533 17.5004 7.5C17.5004 7.23467 17.395 6.98021 17.2074 6.7926C17.0198 6.60498 16.7653 6.49958 16.5 6.49958C16.2347 6.49958 15.9802 6.60498 15.7926 6.7926L15.7926 6.79262L12 10.5861L8.20742 6.79262L8.2074 6.7926C8.01979 6.60498 7.76533 6.49958 7.5 6.49958C7.23467 6.49958 6.98021 6.60498 6.7926 6.7926C6.60498 6.98021 6.49958 7.23467 6.49958 7.5C6.49958 7.76533 6.60498 8.01979 6.7926 8.2074L6.79262 8.20742L10.5861 12L6.79262 15.7926L6.7926 15.7926C6.60498 15.9802 6.49958 16.2347 6.49958 16.5C6.49958 16.7653 6.60498 17.0198 6.7926 17.2074C6.98021 17.395 7.23467 17.5004 7.5 17.5004C7.76533 17.5004 8.01979 17.395 8.2074 17.2074L8.20742 17.2074L12 13.4139L15.7926 17.2074L15.7926 17.2074C15.8855 17.3003 15.9958 17.374 16.1172 17.4243C16.2385 17.4745 16.3686 17.5004 16.5 17.5004C16.6314 17.5004 16.7615 17.4745 16.8828 17.4243C17.0042 17.374 17.1145 17.3003 17.2074 17.2074C17.3003 17.1145 17.374 17.0042 17.4243 16.8828C17.4745 16.7615 17.5004 16.6314 17.5004 16.5C17.5004 16.3686 17.4745 16.2385 17.4243 16.1172C17.374 15.9958 17.3003 15.8855 17.2074 15.7926ZM4.5 3.25H19.5C19.8315 3.25 20.1495 3.3817 20.3839 3.61612C20.6183 3.85054 20.75 4.16848 20.75 4.5V19.5C20.75 19.8315 20.6183 20.1495 20.3839 20.3839C20.1495 20.6183 19.8315 20.75 19.5 20.75H4.5C4.16848 20.75 3.85054 20.6183 3.61612 20.3839C3.3817 20.1495 3.25 19.8315 3.25 19.5V4.5C3.25 4.16848 3.3817 3.85054 3.61612 3.61612C3.85054 3.3817 4.16848 3.25 4.5 3.25Z"
            fill="white"
            stroke="black"
            strokeWidth="0.5"
          />
        </svg>
      );

    case 'icon-review-single':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
        >
          <path
            d="M14.2826 1.11343L10.3779 9.399L1.64075 10.7312C1.28103 10.8007 0.946894 10.9666 0.67396 11.2113C0.401027 11.456 0.19953 11.7702 0.0909509 12.1205C-0.0176283 12.4708 -0.0292192 12.844 0.0574139 13.2004C0.144047 13.5568 0.325657 13.8829 0.582881 14.1441L6.9038 20.586L5.40838 29.6867C5.33884 30.0425 5.37028 30.4108 5.49913 30.7497C5.62798 31.0886 5.84908 31.3845 6.13738 31.604C6.42567 31.8235 6.76962 31.9578 7.13024 31.9916C7.49085 32.0253 7.85371 31.9573 8.17767 31.7951L15.9926 27.4978L23.8076 31.7951C24.1315 31.9573 24.4944 32.0253 24.855 31.9916C25.2156 31.9578 25.5596 31.8235 25.8479 31.604C26.1362 31.3845 26.3573 31.0886 26.4861 30.7497C26.615 30.4108 26.6464 30.0425 26.5769 29.6867L25.0814 20.586L31.4148 14.1441C31.6728 13.883 31.8551 13.5567 31.9421 13.1999C32.0292 12.8431 32.0178 12.4694 31.9092 12.1186C31.8005 11.7678 31.5987 11.4532 31.3253 11.2083C31.0519 10.9635 30.7172 10.7976 30.357 10.7284L21.6198 9.39623L17.7151 1.11343C17.5669 0.781829 17.3259 0.50026 17.0214 0.302693C16.7169 0.105125 16.3617 0 15.9989 0C15.636 0 15.2808 0.105125 14.9763 0.302693C14.6718 0.50026 14.4308 0.781829 14.2826 1.11343Z"
            fill="#FFB73A"
          />
        </svg>
      );

    case 'icon-review-five':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="68"
          height="12"
          viewBox="0 0 68 12"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.9676 4.1779C11.8891 3.963 11.684 3.81792 11.4539 3.81792H7.50286L6.52547 0.395973C6.45784 0.161444 6.24404 0 5.99969 0C5.75644 0 5.54154 0.161444 5.475 0.395973L4.49652 3.81792H0.545519C0.315353 3.81792 0.111367 3.963 0.0328268 4.1779C-0.0457133 4.39388 0.0197368 4.63496 0.196452 4.78331L3.17007 7.26169L1.67017 11.2629C1.58618 11.4876 1.65926 11.7407 1.85016 11.8868C2.03887 12.033 2.30394 12.0374 2.49811 11.8977L5.99969 9.39754L9.50127 11.8977C9.69653 12.0374 9.96051 12.033 10.1503 11.8868C10.3412 11.7407 10.4132 11.4876 10.3292 11.2629L8.82932 7.26169L11.804 4.78331C11.9807 4.63496 12.0451 4.39388 11.9676 4.1779Z"
            fill="#F5D90A"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.9676 4.1779C25.8891 3.963 25.684 3.81792 25.4539 3.81792H21.5029L20.5255 0.395973C20.4578 0.161444 20.244 0 19.9997 0C19.7564 0 19.5415 0.161444 19.475 0.395973L18.4965 3.81792H14.5455C14.3154 3.81792 14.1114 3.963 14.0328 4.1779C13.9543 4.39388 14.0197 4.63496 14.1965 4.78331L17.1701 7.26169L15.6702 11.2629C15.5862 11.4876 15.6593 11.7407 15.8502 11.8868C16.0389 12.033 16.3039 12.0374 16.4981 11.8977L19.9997 9.39754L23.5013 11.8977C23.6965 12.0374 23.9605 12.033 24.1503 11.8868C24.3412 11.7407 24.4132 11.4876 24.3292 11.2629L22.8293 7.26169L25.804 4.78331C25.9807 4.63496 26.0451 4.39388 25.9676 4.1779Z"
            fill="#F5D90A"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M39.9676 4.1779C39.8891 3.963 39.684 3.81792 39.4539 3.81792H35.5029L34.5255 0.395973C34.4578 0.161444 34.244 0 33.9997 0C33.7564 0 33.5415 0.161444 33.475 0.395973L32.4965 3.81792H28.5455C28.3154 3.81792 28.1114 3.963 28.0328 4.1779C27.9543 4.39388 28.0197 4.63496 28.1965 4.78331L31.1701 7.26169L29.6702 11.2629C29.5862 11.4876 29.6593 11.7407 29.8502 11.8868C30.0389 12.033 30.3039 12.0374 30.4981 11.8977L33.9997 9.39754L37.5013 11.8977C37.6965 12.0374 37.9605 12.033 38.1503 11.8868C38.3412 11.7407 38.4132 11.4876 38.3292 11.2629L36.8293 7.26169L39.804 4.78331C39.9807 4.63496 40.0451 4.39388 39.9676 4.1779Z"
            fill="#F5D90A"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M53.9676 4.1779C53.8891 3.963 53.684 3.81792 53.4539 3.81792H49.5029L48.5255 0.395973C48.4578 0.161444 48.244 0 47.9997 0C47.7564 0 47.5415 0.161444 47.475 0.395973L46.4965 3.81792H42.5455C42.3154 3.81792 42.1114 3.963 42.0328 4.1779C41.9543 4.39388 42.0197 4.63496 42.1965 4.78331L45.1701 7.26169L43.6702 11.2629C43.5862 11.4876 43.6593 11.7407 43.8502 11.8868C44.0389 12.033 44.3039 12.0374 44.4981 11.8977L47.9997 9.39754L51.5013 11.8977C51.6965 12.0374 51.9605 12.033 52.1503 11.8868C52.3412 11.7407 52.4132 11.4876 52.3292 11.2629L50.8293 7.26169L53.804 4.78331C53.9807 4.63496 54.0451 4.39388 53.9676 4.1779Z"
            fill="#F5D90A"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M67.9676 4.1779C67.8891 3.963 67.684 3.81792 67.4539 3.81792H63.5029L62.5255 0.395973C62.4578 0.161444 62.244 0 61.9997 0C61.7564 0 61.5415 0.161444 61.475 0.395973L60.4965 3.81792H56.5455C56.3154 3.81792 56.1114 3.963 56.0328 4.1779C55.9543 4.39388 56.0197 4.63496 56.1965 4.78331L59.1701 7.26169L57.6702 11.2629C57.5862 11.4876 57.6593 11.7407 57.8502 11.8868C58.0389 12.033 58.3039 12.0374 58.4981 11.8977L61.9997 9.39754L65.5013 11.8977C65.6965 12.0374 65.9605 12.033 66.1503 11.8868C66.3412 11.7407 66.4132 11.4876 66.3292 11.2629L64.8293 7.26169L67.804 4.78331C67.9807 4.63496 68.0451 4.39388 67.9676 4.1779Z"
            fill="#F5D90A"
          />
        </svg>
      );

    case 'icon-review-four':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="68"
          height="12"
          viewBox="0 0 68 12"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.9676 4.1779C11.8891 3.963 11.684 3.81792 11.4539 3.81792H7.50286L6.52547 0.395973C6.45784 0.161444 6.24404 0 5.99969 0C5.75644 0 5.54154 0.161444 5.475 0.395973L4.49652 3.81792H0.545519C0.315353 3.81792 0.111367 3.963 0.0328268 4.1779C-0.0457133 4.39388 0.0197368 4.63496 0.196452 4.78331L3.17007 7.26169L1.67017 11.2629C1.58618 11.4876 1.65926 11.7407 1.85016 11.8868C2.03887 12.033 2.30394 12.0374 2.49811 11.8977L5.99969 9.39754L9.50127 11.8977C9.69653 12.0374 9.96051 12.033 10.1503 11.8868C10.3412 11.7407 10.4132 11.4876 10.3292 11.2629L8.82932 7.26169L11.804 4.78331C11.9807 4.63496 12.0451 4.39388 11.9676 4.1779Z"
            fill="#F5D90A"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.9676 4.1779C25.8891 3.963 25.684 3.81792 25.4539 3.81792H21.5029L20.5255 0.395973C20.4578 0.161444 20.244 0 19.9997 0C19.7564 0 19.5415 0.161444 19.475 0.395973L18.4965 3.81792H14.5455C14.3154 3.81792 14.1114 3.963 14.0328 4.1779C13.9543 4.39388 14.0197 4.63496 14.1965 4.78331L17.1701 7.26169L15.6702 11.2629C15.5862 11.4876 15.6593 11.7407 15.8502 11.8868C16.0389 12.033 16.3039 12.0374 16.4981 11.8977L19.9997 9.39754L23.5013 11.8977C23.6965 12.0374 23.9605 12.033 24.1503 11.8868C24.3412 11.7407 24.4132 11.4876 24.3292 11.2629L22.8293 7.26169L25.804 4.78331C25.9807 4.63496 26.0451 4.39388 25.9676 4.1779Z"
            fill="#F5D90A"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M39.9676 4.1779C39.8891 3.963 39.684 3.81792 39.4539 3.81792H35.5029L34.5255 0.395973C34.4578 0.161444 34.244 0 33.9997 0C33.7564 0 33.5415 0.161444 33.475 0.395973L32.4965 3.81792H28.5455C28.3154 3.81792 28.1114 3.963 28.0328 4.1779C27.9543 4.39388 28.0197 4.63496 28.1965 4.78331L31.1701 7.26169L29.6702 11.2629C29.5862 11.4876 29.6593 11.7407 29.8502 11.8868C30.0389 12.033 30.3039 12.0374 30.4981 11.8977L33.9997 9.39754L37.5013 11.8977C37.6965 12.0374 37.9605 12.033 38.1503 11.8868C38.3412 11.7407 38.4132 11.4876 38.3292 11.2629L36.8293 7.26169L39.804 4.78331C39.9807 4.63496 40.0451 4.39388 39.9676 4.1779Z"
            fill="#F5D90A"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M53.9676 4.1779C53.8891 3.963 53.684 3.81792 53.4539 3.81792H49.5029L48.5255 0.395973C48.4578 0.161444 48.244 0 47.9997 0C47.7564 0 47.5415 0.161444 47.475 0.395973L46.4965 3.81792H42.5455C42.3154 3.81792 42.1114 3.963 42.0328 4.1779C41.9543 4.39388 42.0197 4.63496 42.1965 4.78331L45.1701 7.26169L43.6702 11.2629C43.5862 11.4876 43.6593 11.7407 43.8502 11.8868C44.0389 12.033 44.3039 12.0374 44.4981 11.8977L47.9997 9.39754L51.5013 11.8977C51.6965 12.0374 51.9605 12.033 52.1503 11.8868C52.3412 11.7407 52.4132 11.4876 52.3292 11.2629L50.8293 7.26169L53.804 4.78331C53.9807 4.63496 54.0451 4.39388 53.9676 4.1779Z"
            fill="#F5D90A"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M67.9676 4.1779C67.8891 3.963 67.684 3.81792 67.4539 3.81792H63.5029L62.5255 0.395973C62.4578 0.161444 62.244 0 61.9997 0C61.7564 0 61.5415 0.161444 61.475 0.395973L60.4965 3.81792H56.5455C56.3154 3.81792 56.1114 3.963 56.0328 4.1779C55.9543 4.39388 56.0197 4.63496 56.1965 4.78331L59.1701 7.26169L57.6702 11.2629C57.5862 11.4876 57.6593 11.7407 57.8502 11.8868C58.0389 12.033 58.3039 12.0374 58.4981 11.8977L61.9997 9.39754L65.5013 11.8977C65.6965 12.0374 65.9605 12.033 66.1503 11.8868C66.3412 11.7407 66.4132 11.4876 66.3292 11.2629L64.8293 7.26169L67.804 4.78331C67.9807 4.63496 68.0451 4.39388 67.9676 4.1779Z"
            fill="#9D9D9D"
          />
        </svg>
      );

    case 'icon-review-three':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="68"
          height="12"
          viewBox="0 0 68 12"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.9676 4.1779C11.8891 3.963 11.684 3.81792 11.4539 3.81792H7.50286L6.52547 0.395973C6.45784 0.161444 6.24404 0 5.99969 0C5.75644 0 5.54154 0.161444 5.475 0.395973L4.49652 3.81792H0.545519C0.315353 3.81792 0.111367 3.963 0.0328268 4.1779C-0.0457133 4.39388 0.0197368 4.63496 0.196452 4.78331L3.17007 7.26169L1.67017 11.2629C1.58618 11.4876 1.65926 11.7407 1.85016 11.8868C2.03887 12.033 2.30394 12.0374 2.49811 11.8977L5.99969 9.39754L9.50127 11.8977C9.69653 12.0374 9.96051 12.033 10.1503 11.8868C10.3412 11.7407 10.4132 11.4876 10.3292 11.2629L8.82932 7.26169L11.804 4.78331C11.9807 4.63496 12.0451 4.39388 11.9676 4.1779Z"
            fill="#F5D90A"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.9676 4.1779C25.8891 3.963 25.684 3.81792 25.4539 3.81792H21.5029L20.5255 0.395973C20.4578 0.161444 20.244 0 19.9997 0C19.7564 0 19.5415 0.161444 19.475 0.395973L18.4965 3.81792H14.5455C14.3154 3.81792 14.1114 3.963 14.0328 4.1779C13.9543 4.39388 14.0197 4.63496 14.1965 4.78331L17.1701 7.26169L15.6702 11.2629C15.5862 11.4876 15.6593 11.7407 15.8502 11.8868C16.0389 12.033 16.3039 12.0374 16.4981 11.8977L19.9997 9.39754L23.5013 11.8977C23.6965 12.0374 23.9605 12.033 24.1503 11.8868C24.3412 11.7407 24.4132 11.4876 24.3292 11.2629L22.8293 7.26169L25.804 4.78331C25.9807 4.63496 26.0451 4.39388 25.9676 4.1779Z"
            fill="#F5D90A"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M39.9676 4.1779C39.8891 3.963 39.684 3.81792 39.4539 3.81792H35.5029L34.5255 0.395973C34.4578 0.161444 34.244 0 33.9997 0C33.7564 0 33.5415 0.161444 33.475 0.395973L32.4965 3.81792H28.5455C28.3154 3.81792 28.1114 3.963 28.0328 4.1779C27.9543 4.39388 28.0197 4.63496 28.1965 4.78331L31.1701 7.26169L29.6702 11.2629C29.5862 11.4876 29.6593 11.7407 29.8502 11.8868C30.0389 12.033 30.3039 12.0374 30.4981 11.8977L33.9997 9.39754L37.5013 11.8977C37.6965 12.0374 37.9605 12.033 38.1503 11.8868C38.3412 11.7407 38.4132 11.4876 38.3292 11.2629L36.8293 7.26169L39.804 4.78331C39.9807 4.63496 40.0451 4.39388 39.9676 4.1779Z"
            fill="#F5D90A"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M53.9676 4.1779C53.8891 3.963 53.684 3.81792 53.4539 3.81792H49.5029L48.5255 0.395973C48.4578 0.161444 48.244 0 47.9997 0C47.7564 0 47.5415 0.161444 47.475 0.395973L46.4965 3.81792H42.5455C42.3154 3.81792 42.1114 3.963 42.0328 4.1779C41.9543 4.39388 42.0197 4.63496 42.1965 4.78331L45.1701 7.26169L43.6702 11.2629C43.5862 11.4876 43.6593 11.7407 43.8502 11.8868C44.0389 12.033 44.3039 12.0374 44.4981 11.8977L47.9997 9.39754L51.5013 11.8977C51.6965 12.0374 51.9605 12.033 52.1503 11.8868C52.3412 11.7407 52.4132 11.4876 52.3292 11.2629L50.8293 7.26169L53.804 4.78331C53.9807 4.63496 54.0451 4.39388 53.9676 4.1779Z"
            fill="#9D9D9D"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M67.9676 4.1779C67.8891 3.963 67.684 3.81792 67.4539 3.81792H63.5029L62.5255 0.395973C62.4578 0.161444 62.244 0 61.9997 0C61.7564 0 61.5415 0.161444 61.475 0.395973L60.4965 3.81792H56.5455C56.3154 3.81792 56.1114 3.963 56.0328 4.1779C55.9543 4.39388 56.0197 4.63496 56.1965 4.78331L59.1701 7.26169L57.6702 11.2629C57.5862 11.4876 57.6593 11.7407 57.8502 11.8868C58.0389 12.033 58.3039 12.0374 58.4981 11.8977L61.9997 9.39754L65.5013 11.8977C65.6965 12.0374 65.9605 12.033 66.1503 11.8868C66.3412 11.7407 66.4132 11.4876 66.3292 11.2629L64.8293 7.26169L67.804 4.78331C67.9807 4.63496 68.0451 4.39388 67.9676 4.1779Z"
            fill="#9D9D9D"
          />
        </svg>
      );

    case 'icon-review-two':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="68"
          height="12"
          viewBox="0 0 68 12"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.9676 4.1779C11.8891 3.963 11.684 3.81792 11.4539 3.81792H7.50286L6.52547 0.395973C6.45784 0.161444 6.24404 0 5.99969 0C5.75644 0 5.54154 0.161444 5.475 0.395973L4.49652 3.81792H0.545519C0.315353 3.81792 0.111367 3.963 0.0328268 4.1779C-0.0457133 4.39388 0.0197368 4.63496 0.196452 4.78331L3.17007 7.26169L1.67017 11.2629C1.58618 11.4876 1.65926 11.7407 1.85016 11.8868C2.03887 12.033 2.30394 12.0374 2.49811 11.8977L5.99969 9.39754L9.50127 11.8977C9.69653 12.0374 9.96051 12.033 10.1503 11.8868C10.3412 11.7407 10.4132 11.4876 10.3292 11.2629L8.82932 7.26169L11.804 4.78331C11.9807 4.63496 12.0451 4.39388 11.9676 4.1779Z"
            fill="#F5D90A"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.9676 4.1779C25.8891 3.963 25.684 3.81792 25.4539 3.81792H21.5029L20.5255 0.395973C20.4578 0.161444 20.244 0 19.9997 0C19.7564 0 19.5415 0.161444 19.475 0.395973L18.4965 3.81792H14.5455C14.3154 3.81792 14.1114 3.963 14.0328 4.1779C13.9543 4.39388 14.0197 4.63496 14.1965 4.78331L17.1701 7.26169L15.6702 11.2629C15.5862 11.4876 15.6593 11.7407 15.8502 11.8868C16.0389 12.033 16.3039 12.0374 16.4981 11.8977L19.9997 9.39754L23.5013 11.8977C23.6965 12.0374 23.9605 12.033 24.1503 11.8868C24.3412 11.7407 24.4132 11.4876 24.3292 11.2629L22.8293 7.26169L25.804 4.78331C25.9807 4.63496 26.0451 4.39388 25.9676 4.1779Z"
            fill="#F5D90A"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M39.9676 4.1779C39.8891 3.963 39.684 3.81792 39.4539 3.81792H35.5029L34.5255 0.395973C34.4578 0.161444 34.244 0 33.9997 0C33.7564 0 33.5415 0.161444 33.475 0.395973L32.4965 3.81792H28.5455C28.3154 3.81792 28.1114 3.963 28.0328 4.1779C27.9543 4.39388 28.0197 4.63496 28.1965 4.78331L31.1701 7.26169L29.6702 11.2629C29.5862 11.4876 29.6593 11.7407 29.8502 11.8868C30.0389 12.033 30.3039 12.0374 30.4981 11.8977L33.9997 9.39754L37.5013 11.8977C37.6965 12.0374 37.9605 12.033 38.1503 11.8868C38.3412 11.7407 38.4132 11.4876 38.3292 11.2629L36.8293 7.26169L39.804 4.78331C39.9807 4.63496 40.0451 4.39388 39.9676 4.1779Z"
            fill="#9D9D9D"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M53.9676 4.1779C53.8891 3.963 53.684 3.81792 53.4539 3.81792H49.5029L48.5255 0.395973C48.4578 0.161444 48.244 0 47.9997 0C47.7564 0 47.5415 0.161444 47.475 0.395973L46.4965 3.81792H42.5455C42.3154 3.81792 42.1114 3.963 42.0328 4.1779C41.9543 4.39388 42.0197 4.63496 42.1965 4.78331L45.1701 7.26169L43.6702 11.2629C43.5862 11.4876 43.6593 11.7407 43.8502 11.8868C44.0389 12.033 44.3039 12.0374 44.4981 11.8977L47.9997 9.39754L51.5013 11.8977C51.6965 12.0374 51.9605 12.033 52.1503 11.8868C52.3412 11.7407 52.4132 11.4876 52.3292 11.2629L50.8293 7.26169L53.804 4.78331C53.9807 4.63496 54.0451 4.39388 53.9676 4.1779Z"
            fill="#9D9D9D"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M67.9676 4.1779C67.8891 3.963 67.684 3.81792 67.4539 3.81792H63.5029L62.5255 0.395973C62.4578 0.161444 62.244 0 61.9997 0C61.7564 0 61.5415 0.161444 61.475 0.395973L60.4965 3.81792H56.5455C56.3154 3.81792 56.1114 3.963 56.0328 4.1779C55.9543 4.39388 56.0197 4.63496 56.1965 4.78331L59.1701 7.26169L57.6702 11.2629C57.5862 11.4876 57.6593 11.7407 57.8502 11.8868C58.0389 12.033 58.3039 12.0374 58.4981 11.8977L61.9997 9.39754L65.5013 11.8977C65.6965 12.0374 65.9605 12.033 66.1503 11.8868C66.3412 11.7407 66.4132 11.4876 66.3292 11.2629L64.8293 7.26169L67.804 4.78331C67.9807 4.63496 68.0451 4.39388 67.9676 4.1779Z"
            fill="#9D9D9D"
          />
        </svg>
      );

    case 'icon-review-one':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="68"
          height="12"
          viewBox="0 0 68 12"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.9676 4.1779C11.8891 3.963 11.684 3.81792 11.4539 3.81792H7.50286L6.52547 0.395973C6.45784 0.161444 6.24404 0 5.99969 0C5.75644 0 5.54154 0.161444 5.475 0.395973L4.49652 3.81792H0.545519C0.315353 3.81792 0.111367 3.963 0.0328268 4.1779C-0.0457133 4.39388 0.0197368 4.63496 0.196452 4.78331L3.17007 7.26169L1.67017 11.2629C1.58618 11.4876 1.65926 11.7407 1.85016 11.8868C2.03887 12.033 2.30394 12.0374 2.49811 11.8977L5.99969 9.39754L9.50127 11.8977C9.69653 12.0374 9.96051 12.033 10.1503 11.8868C10.3412 11.7407 10.4132 11.4876 10.3292 11.2629L8.82932 7.26169L11.804 4.78331C11.9807 4.63496 12.0451 4.39388 11.9676 4.1779Z"
            fill="#F5D90A"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.9676 4.1779C25.8891 3.963 25.684 3.81792 25.4539 3.81792H21.5029L20.5255 0.395973C20.4578 0.161444 20.244 0 19.9997 0C19.7564 0 19.5415 0.161444 19.475 0.395973L18.4965 3.81792H14.5455C14.3154 3.81792 14.1114 3.963 14.0328 4.1779C13.9543 4.39388 14.0197 4.63496 14.1965 4.78331L17.1701 7.26169L15.6702 11.2629C15.5862 11.4876 15.6593 11.7407 15.8502 11.8868C16.0389 12.033 16.3039 12.0374 16.4981 11.8977L19.9997 9.39754L23.5013 11.8977C23.6965 12.0374 23.9605 12.033 24.1503 11.8868C24.3412 11.7407 24.4132 11.4876 24.3292 11.2629L22.8293 7.26169L25.804 4.78331C25.9807 4.63496 26.0451 4.39388 25.9676 4.1779Z"
            fill="#9D9D9D"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M39.9676 4.1779C39.8891 3.963 39.684 3.81792 39.4539 3.81792H35.5029L34.5255 0.395973C34.4578 0.161444 34.244 0 33.9997 0C33.7564 0 33.5415 0.161444 33.475 0.395973L32.4965 3.81792H28.5455C28.3154 3.81792 28.1114 3.963 28.0328 4.1779C27.9543 4.39388 28.0197 4.63496 28.1965 4.78331L31.1701 7.26169L29.6702 11.2629C29.5862 11.4876 29.6593 11.7407 29.8502 11.8868C30.0389 12.033 30.3039 12.0374 30.4981 11.8977L33.9997 9.39754L37.5013 11.8977C37.6965 12.0374 37.9605 12.033 38.1503 11.8868C38.3412 11.7407 38.4132 11.4876 38.3292 11.2629L36.8293 7.26169L39.804 4.78331C39.9807 4.63496 40.0451 4.39388 39.9676 4.1779Z"
            fill="#9D9D9D"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M53.9676 4.1779C53.8891 3.963 53.684 3.81792 53.4539 3.81792H49.5029L48.5255 0.395973C48.4578 0.161444 48.244 0 47.9997 0C47.7564 0 47.5415 0.161444 47.475 0.395973L46.4965 3.81792H42.5455C42.3154 3.81792 42.1114 3.963 42.0328 4.1779C41.9543 4.39388 42.0197 4.63496 42.1965 4.78331L45.1701 7.26169L43.6702 11.2629C43.5862 11.4876 43.6593 11.7407 43.8502 11.8868C44.0389 12.033 44.3039 12.0374 44.4981 11.8977L47.9997 9.39754L51.5013 11.8977C51.6965 12.0374 51.9605 12.033 52.1503 11.8868C52.3412 11.7407 52.4132 11.4876 52.3292 11.2629L50.8293 7.26169L53.804 4.78331C53.9807 4.63496 54.0451 4.39388 53.9676 4.1779Z"
            fill="#9D9D9D"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M67.9676 4.1779C67.8891 3.963 67.684 3.81792 67.4539 3.81792H63.5029L62.5255 0.395973C62.4578 0.161444 62.244 0 61.9997 0C61.7564 0 61.5415 0.161444 61.475 0.395973L60.4965 3.81792H56.5455C56.3154 3.81792 56.1114 3.963 56.0328 4.1779C55.9543 4.39388 56.0197 4.63496 56.1965 4.78331L59.1701 7.26169L57.6702 11.2629C57.5862 11.4876 57.6593 11.7407 57.8502 11.8868C58.0389 12.033 58.3039 12.0374 58.4981 11.8977L61.9997 9.39754L65.5013 11.8977C65.6965 12.0374 65.9605 12.033 66.1503 11.8868C66.3412 11.7407 66.4132 11.4876 66.3292 11.2629L64.8293 7.26169L67.804 4.78331C67.9807 4.63496 68.0451 4.39388 67.9676 4.1779Z"
            fill="#9D9D9D"
          />
        </svg>
      );
    case 'cc-icon':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.25 9C0.25 7.20979 0.961159 5.4929 2.22703 4.22703C3.4929 2.96116 5.20979 2.25 7 2.25H17C18.7902 2.25 20.5071 2.96116 21.773 4.22703C23.0388 5.4929 23.75 7.20979 23.75 9V15C23.75 16.7902 23.0388 18.5071 21.773 19.773C20.5071 21.0388 18.7902 21.75 17 21.75H7C5.20979 21.75 3.4929 21.0388 2.22703 19.773C0.961159 18.5071 0.25 16.7902 0.25 15V9ZM4.75 11.828C4.74981 11.1201 4.95959 10.4281 5.3528 9.83953C5.746 9.25092 6.30497 8.79218 6.95896 8.52133C7.61295 8.25049 8.33259 8.17971 9.02681 8.31796C9.72104 8.45621 10.3587 8.79728 10.859 9.298L11.03 9.47C11.1625 9.61217 11.2346 9.80022 11.2312 9.99452C11.2277 10.1888 11.149 10.3742 11.0116 10.5116C10.8742 10.649 10.6888 10.7277 10.4945 10.7312C10.3002 10.7346 10.1122 10.6625 9.97 10.53L9.798 10.359C9.50738 10.0681 9.137 9.87002 8.73375 9.78973C8.33049 9.70945 7.91247 9.7506 7.53261 9.90798C7.15275 10.0654 6.82812 10.3319 6.5998 10.6739C6.37149 11.0158 6.24975 11.4178 6.25 11.829V12.172C6.24975 12.5832 6.37149 12.9852 6.5998 13.3271C6.82812 13.6691 7.15275 13.9356 7.53261 14.093C7.91247 14.2504 8.33049 14.2916 8.73375 14.2113C9.137 14.131 9.50738 13.9329 9.798 13.642L9.97 13.47C10.0387 13.3963 10.1215 13.3372 10.2135 13.2962C10.3055 13.2552 10.4048 13.2332 10.5055 13.2314C10.6062 13.2296 10.7062 13.2482 10.7996 13.2859C10.893 13.3236 10.9778 13.3797 11.049 13.451C11.1203 13.5222 11.1764 13.607 11.2141 13.7004C11.2518 13.7938 11.2704 13.8938 11.2686 13.9945C11.2668 14.0952 11.2448 14.1945 11.2038 14.2865C11.1628 14.3785 11.1037 14.4613 11.03 14.53L10.859 14.702C10.3587 15.2027 9.72104 15.5438 9.02681 15.682C8.33259 15.8203 7.61295 15.7495 6.95896 15.4787C6.30497 15.2078 5.746 14.7491 5.3528 14.1605C4.95959 13.5719 4.74981 12.8799 4.75 12.172V11.828ZM16.328 8.25C15.3792 8.25053 14.4694 8.62767 13.7986 9.29856C13.1277 9.96945 12.7505 10.8792 12.75 11.828V12.172C12.7498 12.8799 12.9596 13.5719 13.3528 14.1605C13.746 14.7491 14.305 15.2078 14.959 15.4787C15.613 15.7495 16.3326 15.8203 17.0268 15.682C17.721 15.5438 18.3587 15.2027 18.859 14.702L19.03 14.53C19.1037 14.4613 19.1628 14.3785 19.2038 14.2865C19.2448 14.1945 19.2668 14.0952 19.2686 13.9945C19.2704 13.8938 19.2518 13.7938 19.2141 13.7004C19.1764 13.607 19.1203 13.5222 19.049 13.451C18.9778 13.3797 18.893 13.3236 18.7996 13.2859C18.7062 13.2482 18.6062 13.2296 18.5055 13.2314C18.4048 13.2332 18.3055 13.2552 18.2135 13.2962C18.1215 13.3372 18.0387 13.3963 17.97 13.47L17.798 13.641C17.5072 13.9314 17.1369 14.1291 16.7338 14.2091C16.3307 14.2891 15.9129 14.2478 15.5332 14.0905C15.1536 13.9332 14.829 13.6669 14.6006 13.3253C14.3722 12.9836 14.2502 12.582 14.25 12.171V11.828C14.2498 11.4168 14.3715 11.0148 14.5998 10.6729C14.8281 10.3309 15.1528 10.0644 15.5326 9.90698C15.9125 9.7496 16.3305 9.70845 16.7337 9.78873C17.137 9.86902 17.5074 10.0671 17.798 10.358L17.97 10.53C18.1122 10.6625 18.3002 10.7346 18.4945 10.7312C18.6888 10.7277 18.8742 10.649 19.0116 10.5116C19.149 10.3742 19.2277 10.1888 19.2312 9.99452C19.2346 9.80022 19.1625 9.61217 19.03 9.47L18.859 9.298C18.1879 8.62718 17.2779 8.25023 16.329 8.25"
            fill="white"
          />
        </svg>
      );

    case 'minus-icon':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="2"
          viewBox="0 0 12 2"
          fill="none"
        >
          <path
            d="M10.1035 1.91406C10.2676 1.91406 10.4214 1.87077 10.5649 1.78418C10.7085 1.69759 10.8236 1.58252 10.9102 1.43896C10.9967 1.29541 11.04 1.13477 11.04 0.957031C11.04 0.783854 10.9967 0.625488 10.9102 0.481934C10.8236 0.338379 10.7085 0.222168 10.5649 0.133301C10.4214 0.0444336 10.2676 0 10.1035 0H0.943359C0.783854 0 0.632324 0.0444336 0.48877 0.133301C0.345215 0.222168 0.227865 0.338379 0.136719 0.481934C0.0455729 0.625488 0 0.783854 0 0.957031C0 1.13477 0.0455729 1.29541 0.136719 1.43896C0.227865 1.58252 0.345215 1.69759 0.48877 1.78418C0.632324 1.87077 0.783854 1.91406 0.943359 1.91406H10.1035Z"
            fill="white"
          />
        </svg>
      );
    case 'minus-icon-circle':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 24.5C15.3789 24.5 16.7443 24.2284 18.0182 23.7007C19.2921 23.1731 20.4496 22.3996 21.4246 21.4246C22.3996 20.4496 23.1731 19.2921 23.7007 18.0182C24.2284 16.7443 24.5 15.3789 24.5 14C24.5 12.6211 24.2284 11.2557 23.7007 9.98182C23.1731 8.70791 22.3996 7.55039 21.4246 6.57538C20.4496 5.60036 19.2921 4.82694 18.0182 4.29926C16.7443 3.77159 15.3789 3.5 14 3.5C11.2152 3.5 8.54451 4.60625 6.57538 6.57538C4.60625 8.54451 3.5 11.2152 3.5 14C3.5 16.7848 4.60625 19.4555 6.57538 21.4246C8.54451 23.3938 11.2152 24.5 14 24.5ZM8.16667 15.1667H19.8333V12.8333H8.16667V15.1667Z"
            fill="white"
          />
        </svg>
      );
    case 'plus-transparent':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
        >
          <path
            d="M6.18457 11.8682C6.44889 11.8682 6.67448 11.7747 6.86133 11.5879C7.04818 11.401 7.1416 11.1755 7.1416 10.9111L7.141 7.295L10.7646 7.29492C11.0244 7.29492 11.2489 7.20036 11.438 7.01123C11.6271 6.8221 11.7217 6.59538 11.7217 6.33105C11.7217 6.06673 11.6271 5.84115 11.438 5.6543C11.2489 5.46745 11.0244 5.37402 10.7646 5.37402L7.141 5.375L7.1416 1.75098C7.1416 1.49121 7.04818 1.26676 6.86133 1.07764C6.67448 0.888509 6.44889 0.793945 6.18457 0.793945C5.92025 0.793945 5.69466 0.888509 5.50781 1.07764C5.32096 1.26676 5.22754 1.49121 5.22754 1.75098L5.227 5.375L1.60449 5.37402C1.34473 5.37402 1.12028 5.46745 0.931152 5.6543C0.742025 5.84115 0.647461 6.06673 0.647461 6.33105C0.647461 6.59538 0.742025 6.8221 0.931152 7.01123C1.12028 7.20036 1.34473 7.29492 1.60449 7.29492L5.227 7.295L5.22754 10.9111C5.22754 11.1755 5.32096 11.401 5.50781 11.5879C5.69466 11.7747 5.92025 11.8682 6.18457 11.8682Z"
            fill="white"
          />
        </svg>
      );
    case 'filter-icon':
      return (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 0.72 0.72"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.57 0.12v0.18m0 0a0.06 0.06 0 1 0 0 0.12m0 -0.12a0.06 0.06 0 1 1 0 0.12m0 0v0.18M0.36 0.12v0.36m0 0a0.06 0.06 0 1 0 0 0.12 0.06 0.06 0 0 0 0 -0.12ZM0.15 0.24v0.36M0.15 0.24a0.06 0.06 0 1 0 0 -0.12 0.06 0.06 0 0 0 0 0.12Z"
            stroke="#000000"
            strokeWidth="0.045"
            strokeLinecap="round"
          />
        </svg>
      );
    case 'video-rewind-icon':
      return (
        <svg
          className={classNames(className)}
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="40" height="40" fill="white" style={{ mixBlendMode: 'multiply' }} />
          <path
            d="M5 22.5C5 25.4667 5.87973 28.3668 7.52796 30.8336C9.17618 33.3003 11.5189 35.2229 14.2597 36.3582C17.0006 37.4935 20.0166 37.7906 22.9264 37.2118C25.8361 36.633 28.5088 35.2044 30.6066 33.1066C32.7044 31.0088 34.133 28.3361 34.7118 25.4264C35.2906 22.5166 34.9935 19.5006 33.8582 16.7598C32.7229 14.0189 30.8003 11.6762 28.3336 10.028C25.8668 8.37974 22.9667 7.5 20 7.5H15V1.25L7.5 8.75L15 16.25V10H20C22.4723 10 24.889 10.7331 26.9446 12.1066C29.0002 13.4801 30.6024 15.4324 31.5485 17.7165C32.4946 20.0005 32.7421 22.5139 32.2598 24.9386C31.7775 27.3634 30.587 29.5907 28.8388 31.3388C27.0907 33.087 24.8634 34.2775 22.4386 34.7598C20.0139 35.2421 17.5005 34.9946 15.2165 34.0485C12.9324 33.1024 10.9801 31.5002 9.60663 29.4446C8.23311 27.389 7.5 24.9723 7.5 22.5H5Z"
            fill="#E5E5E6"
          />
          <path
            d="M24.5375 27.6625C23.9852 27.676 23.4373 27.5605 22.9375 27.325C22.4937 27.0997 22.1117 26.7693 21.825 26.3625C21.5107 25.8879 21.29 25.3575 21.175 24.8C21.0273 24.1099 20.956 23.4057 20.9625 22.7C20.9574 21.9944 21.0287 21.2903 21.175 20.6C21.2923 20.0432 21.5128 19.5132 21.825 19.0375C22.1117 18.6307 22.4937 18.3003 22.9375 18.075C23.4373 17.8395 23.9852 17.724 24.5375 17.7375C25.0568 17.698 25.5776 17.7921 26.0503 18.0109C26.5229 18.2298 26.9316 18.566 27.2375 18.9875C27.8821 20.0961 28.1864 21.3698 28.1125 22.65C28.1864 23.9302 27.8821 25.2039 27.2375 26.3125C26.9433 26.7524 26.5396 27.1083 26.0662 27.345C25.5928 27.5817 25.066 27.6911 24.5375 27.6625ZM24.5375 26.1375C24.7895 26.1526 25.0406 26.096 25.2618 25.9743C25.483 25.8527 25.6653 25.6709 25.7875 25.45C26.0862 24.8653 26.2446 24.2191 26.25 23.5625V21.8375C26.277 21.1928 26.1529 20.5507 25.8875 19.9625C25.7478 19.7484 25.5569 19.5726 25.3321 19.4509C25.1073 19.3291 24.8556 19.2654 24.6 19.2654C24.3444 19.2654 24.0928 19.3291 23.8679 19.4509C23.6431 19.5726 23.4522 19.7484 23.3125 19.9625C23.0471 20.5507 22.923 21.1928 22.95 21.8375V23.5625C22.9242 24.2112 23.0483 24.857 23.3125 25.45C23.4317 25.6679 23.6098 25.8479 23.8264 25.9694C24.043 26.091 24.2894 26.1492 24.5375 26.1375Z"
            fill="#E5E5E6"
          />
          <path
            d="M13.2875 27.5V26.025H15.7875V19.5375L13.4625 20.7875L12.775 19.4625L15.675 17.8375H17.5V25.9625H19.725V27.5H13.2875Z"
            fill="#E5E5E6"
          />
        </svg>
      );
    case 'video-play-icon':
      return (
        <svg
          className={classNames(className)}
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 62 62"
          fill="none"
          opacity={disabled ? 0.5 : 1}
        >
          <mask
            id="mask0_4105_7818"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="62"
            height="62"
          >
            <path
              d="M30.9005 59.801C46.8623 59.801 59.801 46.8623 59.801 30.9005C59.801 14.9388 46.8623 2 30.9005 2C14.9388 2 2 14.9388 2 30.9005C2 46.8623 14.9388 59.801 30.9005 59.801Z"
              fill="white"
              stroke="white"
              strokeWidth="4"
              strokeLinejoin="round"
            />
            <path
              d="M25.1211 30.9008V20.8896L33.7912 25.8952L42.4614 30.9008L33.7912 35.9064L25.1211 40.9119V30.9008Z"
              fill="black"
              stroke="black"
              strokeWidth="4"
              strokeLinejoin="round"
            />
          </mask>
          <g mask="url(#mask0_4105_7818)">
            <path d="M-3.78125 -3.78027H65.58V65.5809H-3.78125V-3.78027Z" fill="white" />
          </g>
        </svg>
      );
    case 'video-playing-icon':
      return (
        <svg
          fill="#000000"
          width="30px"
          height="30px"
          viewBox="0 0 0.9 0.9"
          id="pause"
          data-name="Flat Color"
          xmlns="http://www.w3.org/2000/svg"
          className={classNames('icon flat-color', className)}
          {...props}
        >
          <path
            id="primary"
            d="M0.713 0.15v0.6a0.075 0.075 0 0 1 -0.075 0.075h-0.075a0.075 0.075 0 0 1 -0.075 -0.075V0.15a0.075 0.075 0 0 1 0.075 -0.075h0.075a0.075 0.075 0 0 1 0.075 0.075M0.337 0.075H0.263a0.075 0.075 0 0 0 -0.075 0.075v0.6a0.075 0.075 0 0 0 0.075 0.075h0.075a0.075 0.075 0 0 0 0.075 -0.075V0.15a0.075 0.075 0 0 0 -0.075 -0.075"
            style={{
              fill: '#ffff',
            }}
          />
        </svg>
      );
    case 'video-forward-icon':
      return (
        <svg
          className={classNames(className)}
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="40" height="40" fill="white" style={{ mixBlendMode: 'multiply' }} />
          <path
            d="M32.5 22.5C32.5 24.9723 31.7669 27.389 30.3934 29.4446C29.0199 31.5002 27.0676 33.1024 24.7836 34.0485C22.4995 34.9946 19.9861 35.2421 17.5614 34.7598C15.1366 34.2775 12.9093 33.087 11.1612 31.3388C9.41302 29.5907 8.22251 27.3634 7.74019 24.9386C7.25788 22.5139 7.50542 20.0005 8.45151 17.7165C9.39761 15.4324 10.9998 13.4801 13.0554 12.1066C15.111 10.7331 17.5277 10 20 10H25V16.25L32.5 8.75L25 1.25V7.5H20C17.0333 7.5 14.1332 8.37974 11.6665 10.028C9.19972 11.6762 7.27713 14.0189 6.14181 16.7598C5.0065 19.5006 4.70945 22.5166 5.28823 25.4264C5.86701 28.3361 7.29562 31.0088 9.3934 33.1066C11.4912 35.2044 14.1639 36.633 17.0737 37.2118C19.9834 37.7906 22.9994 37.4935 25.7403 36.3582C28.4811 35.2229 30.8238 33.3003 32.472 30.8336C34.1203 28.3668 35 25.4667 35 22.5H32.5Z"
            fill="#E5E5E6"
          />
          <path
            d="M24.5375 27.6625C23.9852 27.676 23.4373 27.5605 22.9375 27.325C22.4937 27.0997 22.1118 26.7693 21.825 26.3625C21.5107 25.8879 21.29 25.3575 21.175 24.8C21.0273 24.1099 20.956 23.4057 20.9625 22.7C20.9574 21.9944 21.0287 21.2903 21.175 20.6C21.2923 20.0432 21.5128 19.5132 21.825 19.0375C22.1118 18.6307 22.4937 18.3003 22.9375 18.075C23.4373 17.8395 23.9852 17.724 24.5375 17.7375C25.0568 17.698 25.5776 17.7921 26.0503 18.0109C26.5229 18.2298 26.9316 18.566 27.2375 18.9875C27.8821 20.0961 28.1864 21.3698 28.1125 22.65C28.1864 23.9302 27.8821 25.2039 27.2375 26.3125C26.9433 26.7524 26.5396 27.1083 26.0662 27.345C25.5928 27.5817 25.066 27.6911 24.5375 27.6625ZM24.5375 26.1375C24.7895 26.1526 25.0406 26.096 25.2618 25.9743C25.483 25.8527 25.6653 25.6709 25.7875 25.45C26.0862 24.8653 26.2446 24.2191 26.25 23.5625V21.8375C26.277 21.1928 26.1529 20.5507 25.8875 19.9625C25.7478 19.7484 25.5569 19.5726 25.3321 19.4509C25.1073 19.3291 24.8556 19.2654 24.6 19.2654C24.3444 19.2654 24.0928 19.3291 23.868 19.4509C23.6431 19.5726 23.4522 19.7484 23.3125 19.9625C23.0471 20.5507 22.923 21.1928 22.95 21.8375V23.5625C22.9242 24.2112 23.0483 24.857 23.3125 25.45C23.4317 25.6679 23.6098 25.8479 23.8264 25.9694C24.043 26.091 24.2894 26.1492 24.5375 26.1375Z"
            fill="#E5E5E6"
          />
          <path
            d="M13.2875 27.5V26.025H15.7875V19.5375L13.4625 20.7875L12.775 19.4625L15.675 17.8375H17.5V25.9625H19.725V27.5H13.2875Z"
            fill="#E5E5E6"
          />
        </svg>
      );
    case 'mobile-menu-icon':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'screen-mirror-icon':
      return (
        <svg style={{ fill: 'transparent' }} width="38" height="38" viewBox="0 0 38 38" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M26.2387 29.8571V19C26.2387 18.0402 25.8574 17.1196 25.1787 16.4409C24.5 15.7622 23.5794 15.381 22.6196 15.381H6.33389C5.37406 15.381 4.45354 15.7622 3.77484 16.4409C3.09614 17.1196 2.71484 18.0402 2.71484 19V29.8571C2.71484 30.817 3.09614 31.7375 3.77484 32.4162C4.45354 33.0949 5.37406 33.4762 6.33389 33.4762H22.6196C23.5794 33.4762 24.5 33.0949 25.1787 32.4162C25.8574 31.7375 26.2387 30.817 26.2387 29.8571Z"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M29.8569 29.8571V17.1995C29.8569 15.7598 29.2849 14.379 28.2669 13.3609C27.2488 12.3429 25.868 11.7709 24.4283 11.7709H24.4192L8.14258 11.7999"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M33.476 26.2381V15.3936C33.476 13.474 32.7134 11.6329 31.356 10.2755C29.9986 8.9181 28.1576 8.15552 26.2379 8.15552H26.2252L11.7617 8.17904"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'volume-mute':
      return (
        <svg
          className={classNames(className)}
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.5 1.38889L9.59722 4.29167L12.5 7.19444M1.76389 0L0 1.76389L6.56944 8.33333H0V16.6667H5.55556L12.5 23.6111V14.2639L18.4028 20.1806C17.4722 20.8889 16.4306 21.4722 15.2778 21.8056V24.6806C17.1944 24.2361 18.9306 23.3611 20.3889 22.1667L23.2361 25L25 23.2361L12.5 10.7361"
            fill="white"
          />
        </svg>
      );
    case 'volume-unmute':
      return (
        <svg
          className={classNames(className)}
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 8.33333V16.6667H5.55556L12.5 23.6111V1.38889L5.55556 8.33333H0ZM18.75 12.5C18.75 10.0417 17.3611 7.93055 15.2778 6.90278V18.0833C17.3611 17.0694 18.75 14.9583 18.75 12.5ZM15.2778 0.319444V3.18056C19.2917 4.375 22.2222 8.09722 22.2222 12.5C22.2222 16.9028 19.2917 20.625 15.2778 21.8194V24.6806C21.1111 23.3472 25 18.4028 25 12.5C25 6.59722 21.1111 1.65278 15.2778 0.319444Z"
            fill="white"
          />
        </svg>
      );
    case 'comment-icon':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
        >
          <path
            d="M25.6557 4.66668C25.6557 3.38334 24.6173 2.33334 23.334 2.33334H4.66732C3.38398 2.33334 2.33398 3.38334 2.33398 4.66668V18.6667C2.33398 19.95 3.38398 21 4.66732 21H21.0007L25.6673 25.6667L25.6557 4.66668ZM21.0007 16.3333H7.00065V14H21.0007V16.3333ZM21.0007 12.8333H7.00065V10.5H21.0007V12.8333ZM21.0007 9.33334H7.00065V7.00001H21.0007V9.33334Z"
            fill="white"
          />
        </svg>
      );
    case 'video-expand-icon':
      return (
        <svg
          width="30px"
          height="30px"
          viewBox="0 0 0.9 0.9"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          className={classNames(className)}
        >
          <path
            d="M0.375 0.786c-0.117 -0.005 -0.209 -0.02 -0.225 -0.036s-0.031 -0.108 -0.036 -0.225m0.672 0c-0.005 0.117 -0.02 0.209 -0.036 0.225s-0.108 0.031 -0.225 0.036m0 -0.672c0.117 0.005 0.209 0.02 0.225 0.036s0.031 0.108 0.036 0.225M0.375 0.114c-0.117 0.005 -0.209 0.02 -0.225 0.036s-0.031 0.108 -0.036 0.225"
            stroke="#000000"
            strokeWidth={0.056249999999999994}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'video-collapse-icon':
      return (
        <svg
          className={classNames(className)}
          width="30"
          height="30"
          viewBox="0 0 23 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.16602 6.97919V1.16669M1.16602 1.16669H6.97852M1.16602 1.16669L8.27018 8.27085M21.8327 6.97919V1.16669M21.8327 1.16669H16.0202M21.8327 1.16669L14.7285 8.27085M1.16602 16.0209V21.8334M1.16602 21.8334H6.97852M1.16602 21.8334L8.27018 14.7292M21.8327 16.0209V21.8334M21.8327 21.8334H16.0202M21.8327 21.8334L14.7285 14.7292"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'subtitle-icon':
      return (
        <svg
          className={classNames(className)}
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.375 13.5C0.375 10.8147 1.44174 8.23935 3.34054 6.34054C5.23935 4.44174 7.81468 3.375 10.5 3.375H25.5C28.1853 3.375 30.7606 4.44174 32.6595 6.34054C34.5583 8.23935 35.625 10.8147 35.625 13.5V22.5C35.625 25.1853 34.5583 27.7606 32.6595 29.6595C30.7606 31.5583 28.1853 32.625 25.5 32.625H10.5C7.81468 32.625 5.23935 31.5583 3.34054 29.6595C1.44174 27.7606 0.375 25.1853 0.375 22.5V13.5ZM7.125 17.742C7.12472 16.6802 7.43939 15.6422 8.0292 14.7593C8.61901 13.8764 9.45745 13.1883 10.4384 12.782C11.4194 12.3757 12.4989 12.2696 13.5402 12.4769C14.5816 12.6843 15.538 13.1959 16.2885 13.947L16.545 14.205C16.7437 14.4183 16.8519 14.7003 16.8468 14.9918C16.8416 15.2832 16.7236 15.5613 16.5174 15.7674C16.3113 15.9736 16.0332 16.0916 15.7418 16.0968C15.4503 16.1019 15.1683 15.9937 14.955 15.795L14.697 15.5385C14.2611 15.1022 13.7055 14.805 13.1006 14.6846C12.4957 14.5642 11.8687 14.6259 11.2989 14.862C10.7291 15.0981 10.2422 15.4979 9.8997 16.0108C9.55723 16.5237 9.37462 17.1267 9.375 17.7435V18.258C9.37462 18.8748 9.55723 19.4778 9.8997 19.9907C10.2422 20.5036 10.7291 20.9034 11.2989 21.1395C11.8687 21.3756 12.4957 21.4373 13.1006 21.3169C13.7055 21.1965 14.2611 20.8993 14.697 20.463L14.955 20.205C15.058 20.0945 15.1822 20.0058 15.3202 19.9443C15.4582 19.8828 15.6072 19.8498 15.7582 19.8471C15.9093 19.8444 16.0593 19.8722 16.1994 19.9288C16.3395 19.9854 16.4667 20.0696 16.5736 20.1764C16.6804 20.2833 16.7646 20.4105 16.8212 20.5506C16.8778 20.6907 16.9056 20.8407 16.9029 20.9918C16.9002 21.1428 16.8672 21.2918 16.8057 21.4298C16.7442 21.5678 16.6555 21.692 16.545 21.795L16.2885 22.053C15.538 22.8041 14.5816 23.3157 13.5402 23.5231C12.4989 23.7304 11.4194 23.6243 10.4384 23.218C9.45745 22.8117 8.61901 22.1236 8.0292 21.2407C7.43939 20.3578 7.12472 19.3198 7.125 18.258V17.742ZM24.492 12.375C23.0688 12.3758 21.7042 12.9415 20.6978 13.9478C19.6915 14.9542 19.1258 16.3188 19.125 17.742V18.258C19.1247 19.3198 19.4394 20.3578 20.0292 21.2407C20.619 22.1236 21.4574 22.8117 22.4384 23.218C23.4194 23.6243 24.4989 23.7304 25.5402 23.5231C26.5816 23.3157 27.538 22.8041 28.2885 22.053L28.545 21.795C28.6555 21.692 28.7442 21.5678 28.8057 21.4298C28.8672 21.2918 28.9002 21.1428 28.9029 20.9918C28.9056 20.8407 28.8778 20.6907 28.8212 20.5506C28.7646 20.4105 28.6804 20.2833 28.5736 20.1764C28.4667 20.0696 28.3395 19.9854 28.1994 19.9288C28.0593 19.8722 27.9093 19.8444 27.7582 19.8471C27.6072 19.8498 27.4582 19.8828 27.3202 19.9443C27.1822 20.0058 27.058 20.0945 26.955 20.205L26.697 20.4615C26.2608 20.8971 25.7053 21.1936 25.1006 21.3136C24.496 21.4336 23.8693 21.3717 23.2998 21.1358C22.7303 20.8998 22.2436 20.5004 21.901 19.9879C21.5584 19.4755 21.3753 18.8729 21.375 18.2565V17.742C21.3746 17.1252 21.5572 16.5222 21.8997 16.0093C22.2422 15.4964 22.7291 15.0966 23.2989 14.8605C23.8687 14.6244 24.4957 14.5627 25.1006 14.6831C25.7055 14.8035 26.2611 15.1007 26.697 15.537L26.955 15.795C27.1683 15.9937 27.4503 16.1019 27.7418 16.0968C28.0332 16.0916 28.3113 15.9736 28.5174 15.7674C28.7236 15.5613 28.8416 15.2832 28.8468 14.9918C28.8519 14.7003 28.7437 14.4183 28.545 14.205L28.2885 13.947C27.2818 12.9408 25.9168 12.3754 24.4935 12.375"
            fill="white"
          />
        </svg>
      );
    case 'play-icon':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="178"
          height="178"
          viewBox="0 0 178 178"
          fill="none"
        >
          <g filter="url(#filter0_d_4324_38)">
            <path
              d="M89 11.125C73.5978 11.125 58.5415 15.6923 45.735 24.2493C32.9285 32.8063 22.9471 44.9687 17.0529 59.1985C11.1587 73.4283 9.61656 89.0864 12.6214 104.193C15.6262 119.299 23.0431 133.175 33.9341 144.066C44.8251 154.957 58.7011 162.374 73.8074 165.379C88.9137 168.383 104.572 166.841 118.802 160.947C133.031 155.053 145.194 145.072 153.751 132.265C162.308 119.459 166.875 104.402 166.875 89C166.875 68.3463 158.67 48.5385 144.066 33.9341C129.462 19.3297 109.654 11.125 89 11.125ZM130.424 93.9784L63.674 127.353C62.8257 127.777 61.8832 127.977 60.9359 127.934C59.9886 127.891 59.068 127.607 58.2615 127.108C57.455 126.609 56.7895 125.913 56.328 125.084C55.8666 124.256 55.6246 123.323 55.625 122.375V55.625C55.6255 54.6772 55.8682 53.7452 56.3301 52.9176C56.7919 52.0899 57.4575 51.394 58.2639 50.8958C59.0702 50.3976 59.9904 50.1138 60.9373 50.0711C61.8841 50.0285 62.8261 50.2285 63.674 50.6521L130.424 84.0271C131.347 84.4896 132.123 85.1996 132.665 86.0779C133.207 86.9561 133.494 87.9679 133.494 89C133.494 90.0321 133.207 91.0439 132.665 91.9221C132.123 92.8004 131.347 93.5104 130.424 93.9729"
              fill="white"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_4324_38"
              x="-4"
              y="0"
              width="186"
              height="186"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4324_38" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_4324_38"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      );
    case 'icon-series-white':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="47"
          height="47"
          viewBox="0 0 47 47"
          fill="none"
        >
          <path
            d="M7.91667 10L11.8333 17.8333H17.7083L13.7917 10H17.7083L21.625 17.8333H27.5L23.5833 10H27.5L31.4167 17.8333H37.2917L33.375 10H39.25C40.3271 10 41.2495 10.3838 42.0171 11.1515C42.7848 11.9192 43.168 12.8409 43.1667 13.9167V37.4167C43.1667 38.4937 42.7835 39.4161 42.0171 40.1838C41.2508 40.9515 40.3284 41.3346 39.25 41.3333H7.91667C6.83958 41.3333 5.91786 40.9502 5.1515 40.1838C4.38514 39.4174 4.00131 38.4951 4 37.4167V13.9167C4 12.8396 4.38383 11.9179 5.1515 11.1515C5.91917 10.3851 6.84089 10.0013 7.91667 10Z"
            fill="white"
          />
        </svg>
      );
    case 'icon-film-white':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="33"
          height="32"
          viewBox="0 0 33 32"
          fill="none"
        >
          <g clipPath="url(#clip0_3244_2290)">
            <path
              d="M18.9905 10.7194H2.99895C1.3998 10.7194 0.0942383 11.9917 0.0942383 13.5562V29.1404C0.0942383 30.6988 1.3998 31.9711 2.99895 31.9711H18.9905C20.5959 31.9711 21.8952 30.6988 21.8952 29.1404V13.5562C21.9014 11.9917 20.5959 10.7194 18.9905 10.7194ZM23.3569 17.8053V24.8913L32.0773 29.1404V13.5562L23.3569 17.8053ZM4.45443 9.30099C6.86565 9.30099 8.81462 7.39557 8.81462 5.05186C8.81462 2.70814 6.86565 0.802734 4.45443 0.802734C2.04945 0.802734 0.0942383 2.70814 0.0942383 5.05186C0.0942383 7.39557 2.04945 9.30099 4.45443 9.30099ZM17.5412 0.802734C15.13 0.802734 13.1811 2.70814 13.1811 5.05186C13.1811 7.39557 15.1363 9.30099 17.5412 9.30099C19.9525 9.30099 21.9014 7.39557 21.9014 5.05186C21.9014 2.70814 19.9462 0.802734 17.5412 0.802734Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_3244_2290">
              <rect
                width="31.983"
                height="31.1684"
                fill="white"
                transform="translate(0.0942383 0.802734)"
              />
            </clipPath>
          </defs>
        </svg>
      );
    case 'icon-live-white':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="53"
          height="53"
          viewBox="0 0 53 53"
          fill="none"
        >
          <path
            d="M14.5682 11.2651C14.3955 11.0892 14.1898 10.949 13.9628 10.8525C13.7357 10.756 13.4919 10.7052 13.2452 10.7028C12.9985 10.7004 12.7537 10.7465 12.5249 10.8386C12.296 10.9306 12.0876 11.0668 11.9115 11.2392C9.92005 13.2162 8.34027 15.5669 7.26319 18.156C6.1861 20.745 5.633 23.5212 5.63575 26.3245C5.63283 29.2354 6.22925 32.1159 7.38801 34.7873C8.54678 37.4586 10.2432 39.8639 12.3719 41.8538C12.7303 42.1844 13.2036 42.3626 13.6914 42.3505C14.1793 42.3385 14.6432 42.1371 14.9847 41.7892C15.8021 40.9734 15.7012 39.6748 14.9148 38.9235C13.2062 37.2984 11.8465 35.3434 10.9184 33.1776C9.99034 31.0117 9.51321 28.6801 9.51605 26.3245C9.51605 21.5585 11.4329 17.2367 14.5423 14.0921C15.2925 13.3305 15.3701 12.0654 14.5682 11.2651ZM19.1237 15.8167C18.783 15.4668 18.3172 15.266 17.8284 15.2583C17.3397 15.2505 16.8677 15.4365 16.5161 15.7754C15.1161 17.1537 14.0049 18.7962 13.2473 20.6073C12.4896 22.4184 12.1006 24.3619 12.1029 26.3245C12.1029 30.6928 13.9913 34.6197 16.9998 37.3357C17.3552 37.6484 17.8175 37.8127 18.291 37.7944C18.7644 37.7762 19.2126 37.5768 19.5427 37.2376C20.3912 36.3908 20.2334 35.0586 19.4367 34.3099C18.3449 33.285 17.4752 32.0476 16.8812 30.6742C16.2872 29.3007 15.9816 27.8204 15.9832 26.3245C15.9832 23.3555 17.1654 20.6601 19.0874 18.6825C19.8273 17.9234 19.9489 16.6377 19.1237 15.8167ZM33.5377 15.8141C33.8784 15.4643 34.3441 15.2635 34.8329 15.2557C35.3217 15.248 35.7936 15.4339 36.1452 15.7728C37.5455 17.1514 38.6569 18.7943 39.4146 20.6059C40.1722 22.4175 40.5611 24.3614 40.5584 26.3245C40.5584 30.6928 38.67 34.6197 35.6615 37.3357C35.3061 37.6484 34.8438 37.8127 34.3704 37.7944C33.8969 37.7762 33.4487 37.5768 33.1186 37.2376C32.2701 36.3908 32.4279 35.0586 33.2247 34.3099C34.3164 33.285 35.1862 32.0476 35.7801 30.6742C36.3741 29.3007 36.6797 27.8204 36.6781 26.3245C36.6781 23.3555 35.4959 20.6601 33.5739 18.6825C32.834 17.9234 32.7125 16.6351 33.5377 15.8141ZM38.0931 11.2651C38.2658 11.0892 38.4716 10.949 38.6986 10.8525C38.9256 10.756 39.1694 10.7052 39.4161 10.7028C39.6629 10.7004 39.9076 10.7465 40.1365 10.8386C40.3653 10.9306 40.5737 11.0668 40.7498 11.2392C42.7413 13.2162 44.3211 15.5669 45.3981 18.156C46.4752 20.745 47.0283 23.5212 47.0256 26.3245C47.0285 29.2354 46.4321 32.1159 45.2733 34.7873C44.1146 37.4586 42.4182 39.8639 40.2894 41.8538C39.9311 42.1844 39.4577 42.3626 38.9699 42.3505C38.4821 42.3385 38.0182 42.1371 37.6767 41.7892C36.8592 40.9734 36.9601 39.6748 37.7491 38.9235C39.4572 37.2981 40.8164 35.3431 41.7441 33.1773C42.6717 31.0114 43.1485 28.6799 43.1453 26.3245C43.1453 21.5585 41.2284 17.2367 38.119 14.0921C37.3688 13.3305 37.2912 12.0654 38.0931 11.2651ZM26.3307 22.4518C25.3015 22.4518 24.3146 22.8598 23.5869 23.5861C22.8592 24.3124 22.4504 25.2974 22.4504 26.3245C22.4504 27.3516 22.8592 28.3366 23.5869 29.0629C24.3146 29.7891 25.3015 30.1971 26.3307 30.1971C27.3598 30.1971 28.3468 29.7891 29.0744 29.0629C29.8021 28.3366 30.211 27.3516 30.211 26.3245C30.211 25.2974 29.8021 24.3124 29.0744 23.5861C28.3468 22.8598 27.3598 22.4518 26.3307 22.4518Z"
            fill="white"
          />
        </svg>
      );
    case 'icon-close-modal':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="34"
          height="34"
          viewBox="0 0 34 34"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.0005 19.0032L25.0146 27.0173C25.2818 27.2753 25.6396 27.4181 26.0111 27.4149C26.3825 27.4116 26.7379 27.2627 27.0005 27C27.2632 26.7373 27.4122 26.382 27.4154 26.0106C27.4186 25.6391 27.2758 25.2813 27.0178 25.0141L19.0037 17L27.0178 8.98592C27.2758 8.71873 27.4186 8.36088 27.4154 7.98943C27.4122 7.61799 27.2632 7.26267 27.0005 7.00001C26.7379 6.73735 26.3825 6.58836 26.0111 6.58513C25.6396 6.5819 25.2818 6.72469 25.0146 6.98275L17.0005 14.9968L8.98644 6.98275C8.71805 6.73107 8.36227 6.59368 7.99439 6.59966C7.62651 6.60563 7.27538 6.7545 7.0153 7.01476C6.75523 7.27502 6.60661 7.62625 6.6009 7.99414C6.59518 8.36203 6.73282 8.71771 6.98469 8.98592L14.9974 17L6.98327 25.0141C6.84797 25.1448 6.74004 25.3011 6.6658 25.4739C6.59155 25.6468 6.55247 25.8327 6.55083 26.0208C6.5492 26.2089 6.58504 26.3954 6.65628 26.5695C6.72751 26.7436 6.8327 26.9018 6.96571 27.0348C7.09873 27.1678 7.2569 27.273 7.431 27.3442C7.60511 27.4155 7.79165 27.4513 7.97976 27.4497C8.16786 27.4481 8.35376 27.409 8.5266 27.3347C8.69943 27.2605 8.85576 27.1526 8.98644 27.0173L17.0005 19.0032Z"
            fill="white"
          />
        </svg>
      );
    case 'icon-likes':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M7 11C7.889 10.914 8.416 10.457 9.156 9.943C10.7142 8.44865 12.0475 6.73615 13.114 4.859C13.2473 4.60068 13.4486 4.38357 13.696 4.231C13.9141 4.09634 14.1622 4.0179 14.418 4.00272C14.6739 3.98754 14.9295 4.03608 15.162 4.144C15.367 4.239 15.55 4.377 15.699 4.55C15.8491 4.72432 15.9609 4.92829 16.0271 5.14864C16.0932 5.36899 16.1123 5.6008 16.083 5.829L14.695 9.943M7 11H4V17.5C4 17.8978 4.15804 18.2794 4.43934 18.5607C4.72064 18.842 5.10218 19 5.5 19C5.89782 19 6.27936 18.842 6.56066 18.5607C6.84196 18.2794 7 17.8978 7 17.5V11ZM13.5 10H18.415C18.701 10 18.787 10.014 19.041 10.15C19.295 10.285 19.513 10.482 19.678 10.722C19.8421 10.9647 19.947 11.2424 19.9844 11.5329C20.0217 11.8235 19.9904 12.1187 19.893 12.395L17.795 18.795C17.538 19.52 17.368 20 16.12 20C13.817 20 11.33 19.057 9.45 18.525"
            stroke="#DC2626"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'icon-dislikes':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M17 13C16.111 13.086 15.584 13.543 14.844 14.057C13.2858 15.5514 11.9525 17.2639 10.886 19.141C10.7527 19.3993 10.5514 19.6164 10.304 19.769C10.0859 19.9037 9.83782 19.9821 9.58197 19.9973C9.32611 20.0125 9.07048 19.9639 8.838 19.856C8.633 19.761 8.45 19.623 8.301 19.45C8.15086 19.2757 8.03908 19.0717 7.97293 18.8514C7.90677 18.631 7.88771 18.3992 7.917 18.171L9.305 14.057M17 13L20 13L20 6.5C20 6.10218 19.842 5.72065 19.5607 5.43934C19.2794 5.15804 18.8978 5 18.5 5C18.1022 5 17.7206 5.15804 17.4393 5.43934C17.158 5.72065 17 6.10218 17 6.5L17 13ZM10.5 14L5.585 14C5.299 14 5.213 13.986 4.959 13.85C4.705 13.715 4.487 13.518 4.322 13.278C4.1579 13.0354 4.05297 12.7576 4.01563 12.4671C3.97829 12.1765 4.00959 11.8813 4.107 11.605L6.205 5.205C6.462 4.48 6.632 4 7.88 4C10.183 4 12.67 4.943 14.55 5.475"
            stroke="#DC2626"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'fa-twitter':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M28.7812 28.5L18.7847 13.9295L18.8018 13.9432L27.8151 3.5H24.8031L17.4606 12L11.6297 3.5H3.73022L13.063 17.1034L13.0618 17.1023L3.21875 28.5H6.23078L14.394 19.0432L20.8818 28.5H28.7812ZM10.4362 5.77272L24.4621 26.2273H22.0752L8.03803 5.77272H10.4362Z"
            fill="white"
          />
        </svg>
      );
    case 'fa-instagram':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="31"
          height="31"
          viewBox="0 0 31 31"
          fill="none"
        >
          <path
            d="M16.8278 2.58333C18.2809 2.5872 19.0184 2.59495 19.6552 2.61304L19.9058 2.62208C20.1951 2.63241 20.4806 2.64533 20.8255 2.66083C22.1998 2.72541 23.1375 2.94241 23.9603 3.26145C24.8128 3.58954 25.531 4.03387 26.2492 4.75075C26.9062 5.39623 27.4145 6.17736 27.7385 7.03958C28.0575 7.86237 28.2745 8.80012 28.3391 10.1757C28.3546 10.5193 28.3675 10.8048 28.3778 11.0954L28.3856 11.346C28.405 11.9815 28.4127 12.719 28.4153 14.1722L28.4166 15.1357V16.8278C28.4197 17.77 28.4098 18.7121 28.3869 19.654L28.3791 19.9046C28.3688 20.1952 28.3559 20.4807 28.3404 20.8242C28.2758 22.1999 28.0562 23.1363 27.7385 23.9604C27.4145 24.8226 26.9062 25.6038 26.2492 26.2492C25.6037 26.9063 24.8226 27.4146 23.9603 27.7385C23.1375 28.0576 22.1998 28.2746 20.8255 28.3392L19.9058 28.3779L19.6552 28.3857C19.0184 28.4037 18.2809 28.4128 16.8278 28.4154L15.8642 28.4167H14.1734C13.2308 28.42 12.2882 28.4101 11.3459 28.387L11.0953 28.3792C10.7887 28.3676 10.4821 28.3542 10.1757 28.3392C8.80134 28.2746 7.86359 28.0576 7.0395 27.7385C6.17774 27.4144 5.39708 26.9062 4.75196 26.2492C4.09443 25.6039 3.58573 24.8228 3.26138 23.9604C2.94234 23.1376 2.72534 22.1999 2.66075 20.8242L2.622 19.9046L2.61555 19.654C2.59174 18.7121 2.58097 17.77 2.58325 16.8278V14.1722C2.57968 13.23 2.58915 12.2879 2.61167 11.346L2.62071 11.0954C2.63105 10.8048 2.64396 10.5193 2.65946 10.1757C2.72405 8.80012 2.94105 7.86366 3.26009 7.03958C3.58519 6.177 4.09479 5.39585 4.75325 4.75075C5.39799 4.094 6.1782 3.58576 7.0395 3.26145C7.86359 2.94241 8.80005 2.72541 10.1757 2.66083C10.5193 2.64533 10.806 2.63241 11.0953 2.62208L11.3459 2.61433C12.2878 2.59138 13.2299 2.58148 14.1721 2.58462L16.8278 2.58333ZM15.4999 9.04166C13.7871 9.04166 12.1444 9.72209 10.9332 10.9333C9.72202 12.1444 9.04159 13.7871 9.04159 15.5C9.04159 17.2129 9.72202 18.8556 10.9332 20.0667C12.1444 21.2779 13.7871 21.9583 15.4999 21.9583C17.2128 21.9583 18.8555 21.2779 20.0667 20.0667C21.2778 18.8556 21.9583 17.2129 21.9583 15.5C21.9583 13.7871 21.2778 12.1444 20.0667 10.9333C18.8555 9.72209 17.2128 9.04166 15.4999 9.04166ZM15.4999 11.625C16.0088 11.6249 16.5127 11.7251 16.9829 11.9197C17.453 12.1144 17.8803 12.3997 18.2401 12.7595C18.6 13.1193 18.8855 13.5464 19.0804 14.0165C19.2752 14.4866 19.3755 14.9905 19.3756 15.4994C19.3757 16.0082 19.2755 16.5121 19.0808 16.9823C18.8862 17.4525 18.6008 17.8797 18.2411 18.2396C17.8813 18.5995 17.4542 18.885 16.9841 19.0798C16.514 19.2746 16.0101 19.3749 15.5012 19.375C14.4735 19.375 13.4879 18.9667 12.7612 18.24C12.0345 17.5133 11.6262 16.5277 11.6262 15.5C11.6262 14.4723 12.0345 13.4867 12.7612 12.76C13.4879 12.0333 14.4735 11.625 15.5012 11.625M22.2825 7.10416C21.8542 7.10416 21.4436 7.27427 21.1408 7.57706C20.838 7.87986 20.6679 8.29053 20.6679 8.71875C20.6679 9.14696 20.838 9.55763 21.1408 9.86043C21.4436 10.1632 21.8542 10.3333 22.2825 10.3333C22.7107 10.3333 23.1214 10.1632 23.4241 9.86043C23.7269 9.55763 23.897 9.14696 23.897 8.71875C23.897 8.29053 23.7269 7.87986 23.4241 7.57706C23.1214 7.27427 22.7107 7.10416 22.2825 7.10416Z"
            fill="white"
          />
        </svg>
      );
    case 'fa-tiktok':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
        >
          <path
            d="M22.541 6.489C22.3638 6.39735 22.1913 6.29689 22.0241 6.188C21.5384 5.86684 21.093 5.48846 20.6976 5.061C19.7071 3.92817 19.3373 2.779 19.202 1.97517H19.2066C19.0935 1.30667 19.1401 0.875 19.1483 0.875H14.6391V18.3085C14.6391 18.5418 14.6391 18.774 14.6298 19.0027C14.6298 19.0307 14.6263 19.0563 14.6251 19.0878C14.6251 19.0995 14.6251 19.1135 14.6216 19.1263V19.1368C14.5743 19.7622 14.374 20.3663 14.0383 20.8961C13.7026 21.4258 13.2419 21.865 12.6966 22.1748C12.1278 22.4984 11.4844 22.6681 10.83 22.6672C8.72997 22.6672 7.02663 20.9545 7.02663 18.8393C7.02663 16.723 8.72997 15.0103 10.83 15.0103C11.2278 15.0103 11.6233 15.0733 12.0013 15.197L12.0071 10.605C10.8591 10.4569 9.69293 10.5484 8.58208 10.8737C7.47123 11.199 6.43988 11.751 5.55313 12.495C4.77596 13.17 4.12255 13.9754 3.6223 14.875C3.43213 15.2028 2.71347 16.5223 2.62713 18.662C2.5723 19.8753 2.93747 21.1353 3.1113 21.6545V21.6662C3.2198 21.9718 3.64447 23.0172 4.33513 23.898C4.8921 24.605 5.55016 25.2261 6.28813 25.7413V25.7297L6.29863 25.7413C8.4803 27.223 10.9011 27.1262 10.9011 27.1262C11.32 27.1087 12.7235 27.1262 14.3171 26.3713C16.0846 25.5337 17.0903 24.2865 17.0903 24.2865C17.7333 23.5411 18.2446 22.6917 18.6023 21.7747C19.0106 20.7013 19.146 19.4157 19.146 18.9023V9.65183C19.2008 9.6845 19.93 10.1663 19.93 10.1663C19.93 10.1663 20.98 10.8395 22.6168 11.277C23.7905 11.5885 25.3736 11.655 25.3736 11.655V7.1785C24.8195 7.23917 23.6936 7.06417 22.5398 6.49017"
            fill="white"
          />
        </svg>
      );
    case 'fa-website':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
        >
          <path
            d="M21.1768 17.8333C21.2902 16.8983 21.3752 15.9633 21.3752 15C21.3752 14.0367 21.2902 13.1017 21.1768 12.1667H25.9652C26.1918 13.0733 26.3335 14.0225 26.3335 15C26.3335 15.9775 26.1918 16.9267 25.9652 17.8333M18.6693 25.71C19.5193 24.1375 20.171 22.4375 20.6243 20.6667H24.8035C23.431 23.0301 21.2535 24.8203 18.6693 25.71ZM18.3152 17.8333H11.6852C11.5435 16.8983 11.4585 15.9633 11.4585 15C11.4585 14.0367 11.5435 13.0875 11.6852 12.1667H18.3152C18.4427 13.0875 18.5418 14.0367 18.5418 15C18.5418 15.9633 18.4427 16.8983 18.3152 17.8333ZM15.0002 26.2767C13.8243 24.5767 12.8752 22.6925 12.2943 20.6667H17.706C17.1252 22.6925 16.176 24.5767 15.0002 26.2767ZM9.3335 9.33333H5.19683C6.5549 6.96329 8.73093 5.17009 11.3168 4.29C10.4668 5.8625 9.82933 7.5625 9.3335 9.33333ZM5.19683 20.6667H9.3335C9.82933 22.4375 10.4668 24.1375 11.3168 25.71C8.73604 24.8208 6.56291 23.0299 5.19683 20.6667ZM4.03516 17.8333C3.8085 16.9267 3.66683 15.9775 3.66683 15C3.66683 14.0225 3.8085 13.0733 4.03516 12.1667H8.8235C8.71016 13.1017 8.62516 14.0367 8.62516 15C8.62516 15.9633 8.71016 16.8983 8.8235 17.8333M15.0002 3.70916C16.176 5.40916 17.1252 7.3075 17.706 9.33333H12.2943C12.8752 7.3075 13.8243 5.40916 15.0002 3.70916ZM24.8035 9.33333H20.6243C20.1803 7.57894 19.5237 5.88531 18.6693 4.29C21.276 5.1825 23.4435 6.98166 24.8035 9.33333ZM15.0002 0.833328C7.166 0.833328 0.833496 7.20833 0.833496 15C0.833496 18.7572 2.32605 22.3606 4.98282 25.0173C6.29831 26.3328 7.86003 27.3763 9.57881 28.0883C11.2976 28.8002 13.1398 29.1667 15.0002 29.1667C18.7574 29.1667 22.3607 27.6741 25.0175 25.0173C27.6743 22.3606 29.1668 18.7572 29.1668 15C29.1668 13.1396 28.8004 11.2974 28.0885 9.57865C27.3765 7.85987 26.333 6.29815 25.0175 4.98265C23.702 3.66715 22.1403 2.62364 20.4215 1.9117C18.7027 1.19976 16.8606 0.833328 15.0002 0.833328Z"
            fill="white"
          />
        </svg>
      );

    case 'fa-youtube':
      return (
        <svg
          width="27"
          height="27"
          viewBox="0 0 27 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.1375 0H9.61875L8.60625 3.88125L7.59375 0H5.90625C6.24375 1.0125 6.58125 1.85625 6.91875 2.86875C7.425 4.21875 7.7625 5.4 7.7625 6.075V10.125H9.28125V6.075L11.1375 0ZM15.1875 7.59375V5.0625C15.1875 4.21875 15.0187 3.7125 14.6812 3.20625C14.3438 2.7 13.8375 2.53125 13.1625 2.53125C12.4875 2.53125 11.9813 2.86875 11.6438 3.375C11.3063 3.7125 11.1375 4.21875 11.1375 5.0625V7.7625C11.1375 8.60625 11.3063 9.1125 11.6438 9.45C11.9813 9.95625 12.4875 10.125 13.1625 10.125C13.8375 10.125 14.3438 9.7875 14.6812 9.28125C15.0187 9.1125 15.1875 8.4375 15.1875 7.59375ZM13.8375 7.93125C13.8375 8.60625 13.6688 8.94375 13.1625 8.94375C12.6563 8.94375 12.4875 8.60625 12.4875 7.93125V4.725C12.4875 4.05 12.6563 3.7125 13.1625 3.7125C13.6688 3.7125 13.8375 4.05 13.8375 4.725V7.93125ZM20.25 10.125V2.53125H18.9V8.26875C18.5625 8.775 18.3937 8.94375 18.0562 8.94375C17.8875 8.94375 17.7188 8.775 17.7188 8.60625V2.53125H16.3687V8.4375C16.3687 8.94375 16.3688 9.28125 16.5375 9.61875C16.5375 9.95625 16.875 10.125 17.3813 10.125C17.8875 10.125 18.3937 9.7875 18.9 9.28125V10.125H20.25ZM20.925 17.7188C20.4187 17.7188 20.25 18.0563 20.25 18.7313V19.4062H21.6V18.7313C21.6 18.0563 21.4312 17.7188 20.925 17.7188ZM16.0312 17.7188C15.8625 17.7188 15.525 17.8875 15.3563 18.0562V22.6125C15.525 22.7812 15.8625 22.95 16.0312 22.95C16.3687 22.95 16.5375 22.6125 16.5375 21.9375V18.7313C16.5375 18.0563 16.3687 17.7188 16.0312 17.7188Z"
            fill="white"
          />
          <path
            d="M24.2998 14.0063C23.9623 12.825 22.9498 11.8125 21.9373 11.8125C19.2373 11.475 16.3686 11.475 13.4998 11.475C10.6311 11.475 7.93105 11.475 5.0623 11.8125C4.0498 11.8125 3.0373 12.825 2.6998 14.0063C2.3623 15.6938 2.3623 17.55 2.3623 19.2375C2.3623 20.925 2.3623 22.7813 2.6998 24.4688C3.0373 25.65 3.88105 26.4938 5.0623 26.6625C7.93105 27 10.6311 27 13.4998 27C16.3686 27 19.0686 27 21.9373 26.6625C23.1186 26.4938 24.1311 25.65 24.2998 24.4688C24.6373 22.7813 24.6373 20.925 24.6373 19.2375C24.6373 17.55 24.6373 15.6938 24.2998 14.0063ZM8.7748 15.525H7.0873V24.1313H5.56855V15.525H4.0498V14.0063H8.7748V15.525ZM12.8248 24.1313H11.4748V23.2875C10.9686 23.9625 10.4623 24.1313 9.95605 24.1313C9.4498 24.1313 9.28105 23.9625 9.1123 23.625C9.1123 23.4563 8.94355 23.1188 8.94355 22.4438V16.5375H10.2936V22.4438C10.2936 22.6125 10.4623 22.7813 10.6311 22.7813C10.9686 22.7813 11.1373 22.6125 11.4748 22.1063V16.5375H12.8248V24.1313ZM17.8873 21.7688C17.8873 22.4438 17.8873 22.95 17.7186 23.2875C17.5498 23.7938 17.2123 24.1313 16.7061 24.1313C16.1998 24.1313 15.6936 23.7938 15.3561 23.2875V23.9625H14.0061V14.0063H15.3561V17.2125C15.8623 16.7063 16.1998 16.3688 16.7061 16.3688C17.2123 16.3688 17.5498 16.7063 17.7186 17.2125C17.8873 17.55 17.8873 18.0563 17.8873 18.7313V21.7688ZM22.9498 20.5875H20.2498V21.9375C20.2498 22.6125 20.4186 22.95 20.9248 22.95C21.2623 22.95 21.4311 22.7813 21.5998 22.4438V21.6H22.9498V22.6125C22.9498 22.95 22.7811 23.1188 22.6123 23.4563C22.2748 23.9625 21.7686 24.3 20.9248 24.3C20.2498 24.3 19.7436 23.9625 19.2373 23.4563C18.8998 23.1188 18.7311 22.4438 18.7311 21.7688V19.2375C18.7311 18.3938 18.8998 17.8875 19.0686 17.55C19.4061 17.0438 19.9123 16.7063 20.7561 16.7063C21.4311 16.7063 21.9373 17.0438 22.2748 17.55C22.6123 17.8875 22.6123 18.5625 22.6123 19.2375V20.5875H22.9498Z"
            fill="white"
          />
        </svg>
      );
    case 'fa-facebook':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
        >
          <path
            d="M29.3332 16C29.3332 8.63999 23.3598 2.66666 15.9998 2.66666C8.63984 2.66666 2.6665 8.63999 2.6665 16C2.6665 22.4533 7.25317 27.8267 13.3332 29.0667V20H10.6665V16H13.3332V12.6667C13.3332 10.0933 15.4265 7.99999 17.9998 7.99999H21.3332V12H18.6665C17.9332 12 17.3332 12.6 17.3332 13.3333V16H21.3332V20H17.3332V29.2667C24.0665 28.6 29.3332 22.92 29.3332 16Z"
            fill="white"
          />
        </svg>
      );
    case 'fa-vimeo':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M27.986 7.93566C27.8616 10.661 25.9583 14.3924 22.2763 19.1298C18.4691 24.0765 15.2483 26.5498 12.614 26.5498C10.9807 26.5498 9.60011 25.0437 8.47233 22.0313C7.71944 19.2687 6.96578 16.5064 6.21133 13.7445C5.37367 10.7322 4.47456 9.22561 3.514 9.22483C3.304 9.22561 2.57133 9.66505 1.316 10.5432L0 8.84683C1.38133 7.6335 2.74322 6.419 4.08567 5.20333C5.92978 3.612 7.31267 2.77394 8.23433 2.68916C10.4137 2.47916 11.7549 3.96861 12.2582 7.1575C12.8026 10.5976 13.1798 12.7365 13.3898 13.5742C14.0198 16.4278 14.7117 17.8543 15.4653 17.8535C16.051 17.8535 16.9307 16.9272 18.1043 15.0745C19.2772 13.2249 19.9057 11.816 19.9897 10.8477C20.1577 9.25011 19.5292 8.45094 18.1043 8.45016C17.4339 8.45016 16.7432 8.603 16.0323 8.90866C17.409 4.40377 20.0379 2.21355 23.919 2.338C26.7968 2.42355 28.1524 4.28944 27.986 7.93566Z"
            fill="white"
          />
        </svg>
      );
    case 'fa-linkedIn':
      return (
        <svg width="28" height="28" viewBox="0 0 0.8 0.8" xmlns="http://www.w3.org/2000/svg">
          <path
            fill="#fff"
            d="M0.681 0.681h-0.119V0.495C0.563 0.452 0.562 0.395 0.501 0.395c-0.062 0 -0.071 0.049 -0.071 0.098v0.188h-0.119V0.3h0.114v0.052H0.427A0.119 0.119 0 0 1 0.539 0.29c0.12 0 0.142 0.079 0.142 0.181zM0.178 0.248a0.069 0.069 0 0 1 0 -0.137 0.069 0.069 0 0 1 0 0.137M0.237 0.681H0.119V0.3h0.119zM0.741 0H0.059A0.059 0.059 0 0 0 0 0.058v0.685a0.059 0.059 0 0 0 0.059 0.057h0.681a0.059 0.059 0 0 0 0.059 -0.058V0.058A0.059 0.059 0 0 0 0.741 0"
          />
        </svg>
      );
    case 'fa-rumble':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
        >
          <g clipPath="url(#clip0_2763_1042)">
            <path
              d="M18.0664 16.9325C18.3061 16.738 18.5052 16.4982 18.6522 16.2268C18.7992 15.9554 18.8913 15.6576 18.9232 15.3506C18.9552 15.0436 18.9263 14.7332 18.8382 14.4374C18.7502 14.1415 18.6048 13.8659 18.4102 13.6263C18.307 13.5008 18.1919 13.3856 18.0664 13.2825C16.4164 11.9119 14.6061 10.7467 12.6752 9.8125C11.3427 9.175 9.85518 10.0625 9.64268 11.58C9.31516 13.8577 9.25642 16.1661 9.46768 18.4575C9.61267 19.995 11.0827 20.9125 12.4327 20.3225C14.4534 19.4538 16.3479 18.3169 18.0652 16.9425L18.0664 16.9325ZM26.7314 10.1825C27.9581 11.5265 28.6396 13.2795 28.6428 15.0991C28.6461 16.9187 27.9708 18.6742 26.7489 20.0225C22.3836 24.8406 16.6805 28.2474 10.3689 29.8075C8.75465 30.2115 7.04648 29.9703 5.60714 29.1353C4.1678 28.3002 3.11065 26.9369 2.66017 25.335C0.755175 18.835 1.03518 11.485 2.87268 4.95375C3.83768 1.525 7.06392 -0.628746 10.3852 0.163754C16.5414 1.63125 22.3164 5.40875 26.7314 10.18V10.1825Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_2763_1042">
              <rect width="30" height="30" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'icon-close-white':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M19.5 3H4.5C4.10218 3 3.72064 3.15804 3.43934 3.43934C3.15804 3.72064 3 4.10218 3 4.5V19.5C3 19.8978 3.15804 20.2794 3.43934 20.5607C3.72064 20.842 4.10218 21 4.5 21H19.5C19.8978 21 20.2794 20.842 20.5607 20.5607C20.842 20.2794 21 19.8978 21 19.5V4.5C21 4.10218 20.842 3.72064 20.5607 3.43934C20.2794 3.15804 19.8978 3 19.5 3ZM17.0306 15.9694C17.1003 16.0391 17.1556 16.1218 17.1933 16.2128C17.231 16.3039 17.2504 16.4015 17.2504 16.5C17.2504 16.5985 17.231 16.6961 17.1933 16.7872C17.1556 16.8782 17.1003 16.9609 17.0306 17.0306C16.9609 17.1003 16.8782 17.1556 16.7872 17.1933C16.6961 17.231 16.5985 17.2504 16.5 17.2504C16.4015 17.2504 16.3039 17.231 16.2128 17.1933C16.1218 17.1556 16.0391 17.1003 15.9694 17.0306L12 13.0603L8.03063 17.0306C7.88989 17.1714 7.69902 17.2504 7.5 17.2504C7.30098 17.2504 7.11011 17.1714 6.96937 17.0306C6.82864 16.8899 6.74958 16.699 6.74958 16.5C6.74958 16.301 6.82864 16.1101 6.96937 15.9694L10.9397 12L6.96937 8.03063C6.82864 7.88989 6.74958 7.69902 6.74958 7.5C6.74958 7.30098 6.82864 7.11011 6.96938 6.96938C7.11011 6.82864 7.30098 6.74958 7.5 6.74958C7.69902 6.74958 7.88989 6.82864 8.03063 6.96937L12 10.9397L15.9694 6.96937C16.1101 6.82864 16.301 6.74958 16.5 6.74958C16.699 6.74958 16.8899 6.82864 17.0306 6.96937C17.1714 7.11011 17.2504 7.30098 17.2504 7.5C17.2504 7.69902 17.1714 7.88989 17.0306 8.03063L13.0603 12L17.0306 15.9694Z"
            fill="white"
          />
        </svg>
      );

    case 'video-placeholder':
      return (
        <svg
          width="77"
          height="70"
          viewBox="0 0 77 70"
          fill="#fff"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M40.125 54.875C40.125 56.1075 40.27 57.3037 40.4513 58.5H7.5C5.57718 58.5 3.73311 57.7362 2.37348 56.3765C1.01384 55.0169 0.25 53.1728 0.25 51.25V7.75C0.25 5.82718 1.01384 3.98311 2.37348 2.62348C3.73311 1.26384 5.57718 0.5 7.5 0.5H11.125L18.375 15H29.25L22 0.5H29.25L36.5 15H47.375L40.125 0.5H47.375L54.625 15H65.5L58.25 0.5H72.75V36.0613C70.5387 34.7925 68.11 33.9225 65.5 33.4513V22.25H13.88L7.5 9.45375V51.25H40.4513C40.27 52.4463 40.125 53.6425 40.125 54.875ZM65.5 51.25V40.375H58.25V51.25H47.375V58.5H58.25V69.375H65.5V58.5H76.375V51.25H65.5Z"
            fill="black"
          />
        </svg>
      );
    case 'free-play-video':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="16"
          viewBox="0 0 15 16"
          fill="none"
        >
          <mask
            id="mask0_5135_1252"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="15"
            height="16"
          >
            <path
              d="M7.61279 13.6382C10.5542 13.6382 12.9385 11.2404 12.9385 8.28232C12.9385 5.32427 10.5542 2.92645 7.61279 2.92645C4.67142 2.92645 2.28711 5.32427 2.28711 8.28232C2.28711 11.2404 4.67142 13.6382 7.61279 13.6382Z"
              fill="white"
              stroke="white"
              strokeWidth="4"
              strokeLinejoin="round"
            />
            <path
              d="M6.54883 8.28233V6.42706L8.14653 7.3547L9.74424 8.28233L8.14653 9.20997L6.54883 10.1376V8.28233Z"
              fill="black"
              stroke="black"
              strokeWidth="4"
              strokeLinejoin="round"
            />
          </mask>
          <g mask="url(#mask0_5135_1252)">
            <path d="M-0.376953 0.248535H15.6001V16.3161H-0.376953V0.248535Z" fill="black" />
          </g>
        </svg>
      );
    case 'icon-edit-input':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
        >
          <path
            d="M2.91667 11.0833H3.74792L9.45 5.38125L8.61875 4.55L2.91667 10.2521V11.0833ZM1.75 12.25V9.77083L9.45 2.08542C9.56667 1.97847 9.69558 1.89583 9.83675 1.8375C9.97792 1.77917 10.1261 1.75 10.2813 1.75C10.4364 1.75 10.5871 1.77917 10.7333 1.8375C10.8796 1.89583 11.0059 1.98333 11.1125 2.1L11.9146 2.91667C12.0312 3.02361 12.1164 3.15 12.1701 3.29583C12.2238 3.44167 12.2504 3.5875 12.25 3.73333C12.25 3.88889 12.2234 4.03725 12.1701 4.17842C12.1168 4.31958 12.0316 4.44831 11.9146 4.56458L4.22917 12.25H1.75ZM9.02708 4.97292L8.61875 4.55L9.45 5.38125L9.02708 4.97292Z"
            fill="white"
          />
        </svg>
      );

    case 'coming-soon-media':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="36"
          height="35"
          viewBox="0 0 36 35"
          fill="none"
        >
          <g clipPath="url(#clip0_3152_3996)">
            <path
              d="M6.83366 12L9.75033 17.8333H14.1253L11.2087 12H14.1253L17.042 17.8333H21.417L18.5003 12H21.417L24.3337 17.8333H28.7087L25.792 12H30.167C30.9691 12 31.6559 12.2858 32.2276 12.8575C32.7993 13.4292 33.0846 14.1156 33.0837 14.9167V32.4167C33.0837 33.2188 32.7983 33.9056 32.2276 34.4773C31.6569 35.049 30.97 35.3343 30.167 35.3333H6.83366C6.03158 35.3333 5.34519 35.048 4.77449 34.4773C4.2038 33.9066 3.91796 33.2197 3.91699 32.4167V14.9167C3.91699 14.1146 4.20283 13.4282 4.77449 12.8575C5.34616 12.2868 6.03255 12.001 6.83366 12Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_3152_3996">
              <rect width="35" height="35" fill="white" transform="translate(0.916992)" />
            </clipPath>
          </defs>
        </svg>
      );

    case 'icon-arrow-down-black':
      return (
        <svg
          width="10"
          height="7"
          viewBox="0 0 10 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.68579 5.75897C4.86 5.9323 5.14 5.9323 5.31421 5.75897L8.86967 2.20352C9.04344 2.0293 9.04344 1.74842 8.86967 1.57509C8.6959 1.40087 8.41457 1.40087 8.24124 1.57509L5 4.81589L1.75876 1.57509C1.58498 1.40087 1.30366 1.40087 1.13033 1.57509C0.956557 1.74842 0.956557 2.0293 1.13033 2.20352L4.68579 5.75897Z"
            fill="#595959"
            stroke="#595959"
          />
        </svg>
      );

    case 'icon-arrow-up-black':
      return (
        <svg
          className={classNames(className)}
          width="10"
          height="7"
          viewBox="0 0 10 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.68579 5.75897C4.86 5.9323 5.14 5.9323 5.31421 5.75897L8.86967 2.20352C9.04344 2.0293 9.04344 1.74842 8.86967 1.57509C8.6959 1.40087 8.41457 1.40087 8.24124 1.57509L5 4.81589L1.75876 1.57509C1.58498 1.40087 1.30366 1.40087 1.13033 1.57509C0.956557 1.74842 0.956557 2.0293 1.13033 2.20352L4.68579 5.75897Z"
            fill="#595959"
            stroke="#595959"
          />
        </svg>
      );

    case 'icon-cross-black':
      return (
        <svg
          width="17"
          height="16"
          viewBox="0 0 17 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.96967 3.46967C4.26256 3.17678 4.73744 3.17678 5.03033 3.46967L8.5 6.93934L11.9697 3.46967C12.2626 3.17678 12.7374 3.17678 13.0303 3.46967C13.3232 3.76256 13.3232 4.23744 13.0303 4.53033L9.56066 8L13.0303 11.4697C13.3232 11.7626 13.3232 12.2374 13.0303 12.5303C12.7374 12.8232 12.2626 12.8232 11.9697 12.5303L8.5 9.06066L5.03033 12.5303C4.73744 12.8232 4.26256 12.8232 3.96967 12.5303C3.67678 12.2374 3.67678 11.7626 3.96967 11.4697L7.43934 8L3.96967 4.53033C3.67678 4.23744 3.67678 3.76256 3.96967 3.46967Z"
            fill="black"
          />
        </svg>
      );

    case 'icon-cross-circle-black-italic':
      return (
        <svg
          width="19"
          height="18"
          viewBox="0 0 19 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.0501 6.59998L6.9502 11.4M12.0501 11.4L6.9502 6.59998L12.0501 11.4Z"
            stroke="black"
            strokeOpacity="0.6"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M9.49991 17C14.1943 17 17.9998 13.4183 17.9998 9C17.9998 4.58172 14.1943 1 9.49991 1C4.80554 1 1 4.58172 1 9C1 13.4183 4.80554 17 9.49991 17Z"
            stroke="black"
            strokeOpacity="0.6"
            strokeWidth="2"
          />
        </svg>
      );

    case 'icon-plus-white-black-background':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="35"
          height="33"
          viewBox="0 0 35 33"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.2499 0C7.72327 0 0 7.3875 0 16.5C0 25.6125 7.72327 33 17.2499 33C26.7766 33 34.4999 25.6125 34.4999 16.5C34.4999 7.3875 26.7766 0 17.2499 0ZM18.8181 22.5C18.8181 22.8978 18.6529 23.2794 18.3588 23.5607C18.0647 23.842 17.6658 24 17.2499 24C16.834 24 16.4352 23.842 16.1411 23.5607C15.847 23.2794 15.6818 22.8978 15.6818 22.5V18H10.9772C10.5613 18 10.1625 17.842 9.86836 17.5607C9.57427 17.2794 9.40905 16.8978 9.40905 16.5C9.40905 16.1022 9.57427 15.7206 9.86836 15.4393C10.1625 15.158 10.5613 15 10.9772 15H15.6818V10.5C15.6818 10.1022 15.847 9.72064 16.1411 9.43934C16.4352 9.15804 16.834 9 17.2499 9C17.6658 9 18.0647 9.15804 18.3588 9.43934C18.6529 9.72064 18.8181 10.1022 18.8181 10.5V15H23.5226C23.9385 15 24.3374 15.158 24.6315 15.4393C24.9256 15.7206 25.0908 16.1022 25.0908 16.5C25.0908 16.8978 24.9256 17.2794 24.6315 17.5607C24.3374 17.842 23.9385 18 23.5226 18H18.8181V22.5Z"
            fill="black"
          />
        </svg>
      );

    case "preview_icon":
      return (
        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px" viewBox="0 0 30 30" style={{enableBackground:"new 0 0 469 469"}}  width="30" height="30"><g><g><path d="M29.136 0h-28.273C0.384 0 0 0.384 0 0.864v13.554c0 0.48 0.384 0.864 0.864 0.864s0.864 -0.384 0.864 -0.864V1.727h26.546v26.546H15.505c-0.48 0 -0.864 0.384 -0.864 0.864s0.384 0.864 0.864 0.864h13.631c0.48 0 0.864 -0.384 0.864 -0.864v-28.273C30 0.384 29.616 0 29.136 0" /><path d="M11.232 17.904H0.864c-0.48 0 -0.864 0.384 -0.864 0.864v10.369C0 29.616 0.384 30 0.864 30h10.369c0.48 0 0.864 -0.384 0.864 -0.864V18.768c0 -0.473 -0.39 -0.864 -0.864 -0.864M10.369 28.273H1.727V19.631h8.642z" /><path d="M23.053 8.168v4.574c0 0.48 0.384 0.864 0.864 0.864s0.864 -0.384 0.864 -0.864V6.083c0 -0.48 -0.384 -0.864 -0.864 -0.864H17.258c-0.48 0 -0.864 0.384 -0.864 0.864s0.384 0.864 0.864 0.864h4.574L13.593 15.186c-0.339 0.339 -0.339 0.883 0 1.222 0.166 0.166 0.39 0.256 0.608 0.256s0.441 -0.083 0.608 -0.256z" /></g></g></svg>
      )

    default:
      return null;
  }
};

export default IconCollection;
